// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T19:54:11.799Z
// Property: Sunstone Parc Apartments (ID: 6767906449166912)
// Collections: 19 amenities, 3 floorplans (live), 27 photos, 39 POIs, 2 reviews, 5 virtual tours, 7 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166912",
  "property_external_id": "495840",
  "property_zillow_url": "https://www.zillow.com/apartments/beaverton-or/french-chateau-apartments/9VJmRr/",
  "property_apartments_url": "https://www.apartments.com/sunstone-parc-apartments-beaverton-or/dj07exh/",
  "property_google_business_url": "https://www.google.com/maps/place/Sunstone+Parc+Apartments/data=!4m2!3m1!1s0x0:0xba0587b67527d267?sa=X&ved=2ahUKEwjRg8PhnLySAxXbjK8BHRXKGYsQ_BJ6BAgZEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495840 p0505508",
  "property_status": null,
  "property_slug": "sunstone-parc-apartments",
  "property_name": "Sunstone Parc Apartments",
  "property_website_url": "www.beaverton-apartments.net",
  "property_domain": "https://www.beaverton-apartments.net/",
  "property_address": "12000 SW Pioneer Lane",
  "property_full_address": "12000 SW Pioneer Lane, Beaverton, OR, 97008",
  "property_address_1": "12000 SW Pioneer Lane",
  "property_address_2": null,
  "property_address_city": "Beaverton",
  "property_address_state": "OR",
  "property_address_zip_full": null,
  "property_address_zip": "97008",
  "property_address_country": "US",
  "property_address_county": "Washington County",
  "property_neighborhood_address": "Greenway",
  "property_address_latitude": "45.4448",
  "property_address_longitude": "-122.8027",
  "property_email": "sunstoneparc@ctlmanagement.com",
  "property_phone": "(503) 966-2852",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Sunstone Parc in Beaverton, OR, where modern living meets comfort. Choose from spacious one, two, or three-bedroom floor plans featuring amenities like a refreshing swimming pool, a vibrant clubhouse, and a fully-equipped fitness center. Elevate your lifestyle with conveniences designed just for you—schedule a tour today!",
  "property_long_description": "Welcome to Sunstone Parc, where comfort meets convenience in the heart of Beaverton, OR. Our thoughtfully designed apartment community offers a range of floor plans to suit any lifestyle, featuring one, two, and three-bedroom options that maximize space and enhance your living experience. \n\nAt Sunstone Parc, you'll enjoy an array of premium amenities to elevate your daily life. Stay active in our state-of-the-art, 24-hour fitness center, or unwind at the sparkling swimming pool and luxurious outdoor spa. For residents who work from home, our modern business center with guest Wi-Fi ensures you can be productive in a comfortable environment. \n\nGather with neighbors in the welcoming clubhouse, participate in our vibrant resident activity program, or take advantage of the convenience of online rent payments and service requests. Our smoke-free housing, complete with ceiling fans, curved shower bars, and personal patios, guarantees a tranquil living space with every aspect of your comfort in mind. Need extra storage? We've got you covered.\n\nEnjoy the peace of mind that comes with covered parking and available garages, along with package acceptance services for your convenience. Plus, be captivated by stunning wetland views right from your private patio.\n\nExperience the best of apartment living at Sunstone Parc. Don’t wait any longer—find your new home today by browsing our availability or scheduling a tour to discover all that our community has to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019db194-8241-7668-b6d9-d5a60f34d31b.webp",
  "property_featured_image_media": {
    "alt_text": "An inviting swimming pool with lounge chairs and umbrellas.",
    "public_id": "019db194-8241-7668-b6d9-d5a60f34d31b",
    "storage_key": "property/6767906449166912/019db194-8241-7668-b6d9-d5a60f34d31b.webp",
    "width": 1920,
    "height": 896
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "158",
  "property_year_built": "1990",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.56962025316456",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Deposit: $400",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "400",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Deposit and monthly pet rent are per pet.  Small caged animals are allowed without a deposit and pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Max 2 Allowed | Max weight 25 lb each\nRent $25 | Deposit $400",
  "property_online_leasing_url": "https://beaverton-apartments.securecafe.com/onlineleasing/sunstone-parc-apartments/floorplans.aspx",
  "property_resident_portal_url": "https://beaverton-apartments.securecafe.com/residentservices/sunstone-parc-apartments/userlogin.aspx",
  "property_apply_now_url": "https://beaverton-apartments.securecafe.com/onlineleasing/sunstone-parc-apartments/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d7412-4649-707a-9fbe-2ad745df79b9.webp",
  "property_primary_logo_media": {
    "alt_text": "Sunstone Parc Apartments logo",
    "public_id": "019d7412-4649-707a-9fbe-2ad745df79b9",
    "storage_key": "property/6767906449166912/019d7412-4649-707a-9fbe-2ad745df79b9.webp",
    "width": 697,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d7412-4649-707a-9fbe-25ff7de5ff79.webp",
  "property_secondary_logo_media": {
    "alt_text": "Sunstone Parc Apartments logo",
    "public_id": "019d7412-4649-707a-9fbe-25ff7de5ff79",
    "storage_key": "property/6767906449166912/019d7412-4649-707a-9fbe-25ff7de5ff79.webp",
    "width": 706,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019de0b2-532f-717d-85f4-e78a83d7f95e.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Placeholder image",
    "public_id": "019de0b2-532f-717d-85f4-e78a83d7f95e",
    "storage_key": "property/6767906449166912/019de0b2-532f-717d-85f4-e78a83d7f95e.webp",
    "width": 697,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019de0b2-46ed-74dc-a8b1-aec54c99292a.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Black horizontal bar",
    "public_id": "019de0b2-46ed-74dc-a8b1-aec54c99292a",
    "storage_key": "property/6767906449166912/019de0b2-46ed-74dc-a8b1-aec54c99292a.webp",
    "width": 697,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "620 - 906",
  "property_sqft_min": "620",
  "property_sqft_max": "906",
  "property_price_range": "1595 - 2910",
  "property_price_min": "1595",
  "property_price_max": "2910",
  "property_available_units": 7,
  "property_facebook_url": "https://www.facebook.com/sunstoneparcapartments/about/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJlWvKngcNlVQRZ9IndbaHBbo",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/sunstone-parc-apartments-beaverton",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Sunstone Parc",
  "property_home_romance_title": "Embrace the Love of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "Welcome to Sunstone Parc in Beaverton, OR, where modern living meets exceptional comfort. Choose from spacious one, two, or three-bedroom floor plans, and enjoy amenities like a 24-hour fitness center, outdoor spa, and a serene wetland view. Elevate your lifestyle while experiencing community warmth and convenience.",
  "property_home_floorplans_blurb": "Welcome to Sunstone Parc in beautiful Beaverton, OR, where modern living meets comfort. With a variety of thoughtfully designed floor plans, you can choose the ideal space that suits your lifestyle. Browse our available apartment homes today and take the first step towards your new beginning at Sunstone Parc!",
  "property_home_gallery_blurb": "At Sunstone Parc in Beaverton, OR, our diverse floor plans—one, two, and three bedrooms—are just the beginning. Enjoy modern amenities like a 24-hour fitness center, outdoor spa, and private patios with wetland views. Picture yourself living here amid comfort and community conveniences, where every day feels like a retreat!",
  "property_home_neighborhood_blurb": "Welcome to Sunstone Parc in Beaverton, OR, where vibrant living meets natural beauty. Nestled near the serene Tualatin Hills Nature Park and the historic Fogelbo Log Home, our community offers spacious one, two, and three-bedroom layouts. Enjoy easy access to local favorites and essential amenities. Adventure awaits!",
  "property_home_reviews_blurb": "Nestled in vibrant Beaverton, OR, Sunstone Parc shines with glowing resident reviews like, \"The community atmosphere is warm and welcoming!\" Dive into the authentic experiences that make this apartment community a true gem. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Sunstone Parc in Beaverton, OR, boasts easy access to vibrant parks, scenic trails, and thriving local attractions. From Tryon Creek State Natural Area to the enriching Oregon Zoo, there’s always something to explore. Unwind at Gabriel Park or shop at the Columbia Sportswear Company Employee Store — adventure awaits!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Sunstone Parc in Beaverton, OR, lifestyle meets comfort. Choose from spacious one, two, or three-bedroom floor plans, complemented by a vibrant array of amenities. Unwind by the outdoor spa, stay fit in our 24-hour fitness center, or host friends in the inviting clubhouse. Your new home awaits!",
  "property_applynow_blurb": "At Sunstone Parc in Beaverton, OR, embrace a lifestyle of comfort and convenience. Choose from spacious one to three-bedroom floor plans enhanced by amenities like a refreshing swimming pool, 24-hour fitness center, and outdoor spa. Ready to elevate your living? Lease your new home online today!",
  "property_contactus_blurb": "At Sunstone Parc in Beaverton, OR, our thoughtfully designed one, two, and three-bedroom floor plans cater to your lifestyle needs. Experience modern living with spacious layouts and exceptional amenities. Have questions? Contact our leasing team today to find your perfect home in our vibrant community!",
  "property_faqs_blurb": "At Sunstone Parc in Beaverton, OR, our versatile floor plans cater to every lifestyle—whether you seek the intimacy of a one-bedroom retreat, the comfort of a two-bedroom space, or the expansive luxury of a three-bedroom haven. Have questions? Browse our FAQs to learn more about our vibrant community!",
  "property_floorplans_blurb": "At Sunstone Parc in Beaverton, OR, your ideal living space awaits. Choose from our thoughtfully designed one, two, or three-bedroom floor plans that cater to your lifestyle. Each layout offers unique features and ample space. Browse our available apartment homes to find the perfect fit for your needs!",
  "property_gallery_blurb": "At Sunstone Parc in Beaverton, OR, vibrant community living meets modern comfort. With spacious one, two, and three-bedroom floor plans, enjoy amenities like a shimmering swimming pool, 24-hour fitness center, and a serene outdoor spa. Picture yourself unwinding on your private patio with stunning wetland views!",
  "property_interactivemap_blurb": "Welcome to Sunstone Parc in Beaverton, OR, where modern living meets serene wetland views. Choose from spacious one, two, or three-bedroom floor plans and enjoy exceptional amenities like our 24-hour fitness center, outdoor spa, and inviting clubhouse. Use our interactive community map to find your ideal home today!",
  "property_pets_blurb": "At Sunstone Parc in Beaverton, OR, your pets are family! With a welcoming space for indoor cats and dogs under 25 lbs, as well as room for small caged companions, your home will feel lively and vibrant. Enjoy pet-friendly living amid beautiful surroundings designed for comfort and joy.",
  "property_referafriend_blurb": "At Sunstone Parc in Beaverton, OR, our vibrant community thrives on connection. With a range of one, two, and three-bedroom floor plans, there's a perfect space for everyone. Great friends make great neighbors—refer a friend today and enjoy the warmth of shared living in our welcoming environment!",
  "property_residentaccess_blurb": "At Sunstone Parc in Beaverton, OR, we offer a range of one, two, and three-bedroom apartment floor plans designed for your comfort and style. Access your resident portal for easy rent payments, maintenance requests, and more – your seamless living experience starts here!",
  "property_reviews_blurb": "At Sunstone Parc in Beaverton, OR, residents love the vibrant community atmosphere. One tenant raves, \"The staff is incredibly welcoming, making every day feel like home.\" Curious about life here? Dive into our reviews and see why Sunstone Parc is more than just an apartment—it's a place to thrive!",
  "property_created_at": "1762785205953",
  "property_scheduletour_blurb": "At Sunstone Parc in Beaverton, OR, our diverse floor plans cater to every lifestyle—choose from cozy one-bedroom retreats to spacious three-bedroom havens. Imagine your ideal home surrounded by vibrant community life. Curious about living here? Schedule a tour and hear firsthand from our delighted residents!",
  "property_thankyou_blurb": "Thank you for reaching out to Sunstone Parc in Beaverton, OR! With a variety of thoughtfully designed floor plans—one, two, and three bedrooms—your perfect home awaits. Stay tuned; a friendly team member will be in touch soon to assist you in your apartment search!",
  "property_virtualtours_blurb": "Welcome to Sunstone Parc, where modern living meets serene surroundings in Beaverton, OR. Our thoughtfully designed one, two, and three-bedroom floor plans offer the perfect blend of comfort and style. Ready to envision your future home? Take a virtual tour of our community and apartments for rent today!",
  "property_copyright": "2025 All Rights Reserved. Sunstone Parc",
  "property_seo_title_home": "Sunstone Parc |  Apartments in Beaverton, OR",
  "property_seo_description_home": "Welcome to Sunstone Parc in Beaverton, OR! Choose from spacious one to three-bedroom apartments with top-notch amenities. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Beaverton, OR Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Sunstone Parc in Beaverton, OR. Choose from stylish one, two, or three-bedroom floor plans that suit your lifestyle perfectly!",
  "property_seo_title_amenities": "Amenities | Beaverton, OR Apartments for Rent",
  "property_seo_description_amenities": "Experience unmatched comfort at Sunstone Parc in Beaverton, OR, with top amenities like a fitness center, spa, and stunning views.",
  "property_seo_title_gallery": "Gallery | Apartments in Beaverton, OR",
  "property_seo_description_gallery": "Experience Sunstone Parc in Beaverton! Discover beautiful floor plans, amenities like a pool and fitness center, and serene wetland views.",
  "property_seo_title_virtualtours": "Virtual Tours | Sunstone Parc Apartments",
  "property_seo_description_virtualtours": "Step into Sunstone Parc in Beaverton, OR! Experience spacious one, two, and three-bedroom homes. Take a virtual tour and imagine your new life today!",
  "property_seo_title_interactivemap": "Interactive Map | Sunstone Parc Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Sunstone Parc in Beaverton, OR. Check out our interactive map for floor plans, prices, and amenities like a pool and fitness center!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Beaverton, OR",
  "property_seo_description_neighborhood": "Uncover the vibrant Beaverton neighborhood surrounding Sunstone Parc. From local favorites to hidden gems, find your perfect backdrop for life and leisure!",
  "property_seo_title_contact": "Contact Us | Sunstone Parc",
  "property_seo_description_contact": "Connect with Sunstone Parc in Beaverton, OR! Our friendly leasing team is ready to answer your questions about our one, two, and three-bedroom floor plans.",
  "property_seo_title_faqs": "FAQs | Apartments in Beaverton, OR",
  "property_seo_description_faqs": "Discover answers about Sunstone Parc in Beaverton, OR! Our FAQs cover everything from floor plans to amenities of our vibrant community.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Beaverton, OR",
  "property_seo_description_reviews": "Experience the vibrancy of Sunstone Parc in Beaverton, OR. Check out what our residents love about our community's amenities, comfort, and lifestyle!",
  "property_seo_title_applynow": "Apply Now | Apartments in Beaverton, OR",
  "property_seo_description_applynow": "Experience modern living at Sunstone Parc in Beaverton, OR. Choose from stylish one to three-bedroom apartments with top-notch amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Sunstone Parc",
  "property_seo_description_residentaccess": "Access your Sunstone Parc resident portal for seamless rent payments, quick maintenance requests, and essential community updates—all in one convenient place!",
  "property_seo_title_referafriend": "Refer A Friend | Sunstone Parc",
  "property_seo_description_referafriend": "Refer a friend to Sunstone Parc in Beaverton, OR! Great friends make great neighbors—share the joy of vibrant living in our welcoming community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Sunstone Parc",
  "property_seo_description_scheduletour": "Experience vibrant living at Sunstone Parc in Beaverton, OR. Schedule a tour today and envision your new home surrounded by comfort and community!",
  "property_seo_title_privacy": "Privacy Policy | Sunstone Parc",
  "property_seo_description_privacy": "At Sunstone Parc in Beaverton, your privacy matters. Review our policy to understand how we protect your information while you enjoy our vibrant community.",
  "property_seo_title_accessibility": "Website Accessibility | Sunstone Parc",
  "property_seo_description_accessibility": "At Sunstone Parc in Beaverton, OR, we embrace digital inclusion. Dive into our accessibility resources and ensure every resident feels at home—online and off!",
  "property_seo_title_sitemap": "Sitemap | Sunstone Parc",
  "property_seo_description_sitemap": "Unearth your future home at Sunstone Parc in Beaverton, OR! Navigate our sitemap for a glimpse into vibrant living and exceptional amenities tailored for you.",
  "property_seo_title_thankyou": "Thank You | Sunstone Parc",
  "property_seo_description_thankyou": "Thank you for connecting with Sunstone Parc! Your journey to vibrant living in Beaverton begins here. Our team will reach out to you soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Beaverton, OR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1778874858868",
  "amenities": [
    {
      "id": "ec_65d5fd71f11a32e31ef2e701",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "yardi",
      "external_id": "80429590",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019f4fc5-5907-718c-a9fe-a552b9997594.webp",
      "amenity_image_media": {
        "alt_text": "Modern living room and kitchen area with white sofa, green chairs, and island.",
        "public_id": "019f4fc5-5907-718c-a9fe-a552b9997594",
        "storage_key": "property/6767906449166912/019f4fc5-5907-718c-a9fe-a552b9997594.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "A modern living room with a white couch and green armchairs at Sunstone Parc, Beaverton, OR, 97008",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_03849301b6626d1afb2303b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "yardi",
      "external_id": "86134939",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4978-7e45-7629-85fb-cc46d1c5269e.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with treadmills and ellipticals.",
        "public_id": "019d4978-7e45-7629-85fb-cc46d1c5269e",
        "storage_key": "property/6767906449166912/019d4978-7e45-7629-85fb-cc46d1c5269e.webp",
        "width": 480,
        "height": 640
      },
      "amenity_image_alt_text": "Sunstone Parc fitness center cardio machines,Sunstone Parc fitness center with exercise balls and free weights",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9ac58b49a6e7872822958dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "yardi",
      "external_id": "80429588",
      "title": "Business Center with Guest Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019f4fc5-5c5c-74c7-8414-ef94224a70d2.webp",
      "amenity_image_media": {
        "alt_text": "Business center with computers, printers, and seating.",
        "public_id": "019f4fc5-5c5c-74c7-8414-ef94224a70d2",
        "storage_key": "property/6767906449166912/019f4fc5-5c5c-74c7-8414-ef94224a70d2.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "A room with a brown couch, a desk with chairs, and a potted plant at Sunstone Parc, Beaverton, OR, 97008",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e086e9284e3d0442fe007509",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "yardi",
      "external_id": "80429598",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b0-3ec6-7227-a00c-6b5d12af1c08.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d08b0-3ec6-7227-a00c-6b5d12af1c08",
        "storage_key": "property/6767906449166912/019d08b0-3ec6-7227-a00c-6b5d12af1c08.webp",
        "width": 900,
        "height": 600
      },
      "amenity_image_alt_text": "Sunstone Parc Pool & Sundeck,Sunstone Parc Pool & Furniture",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_320e53aa409215c51da0a695",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "yardi",
      "external_id": "80429593",
      "title": "Garages Available to Rent",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_87de26ea57b77910e29e8379",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "yardi",
      "external_id": "80429591",
      "title": "Covered Parking - With Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_659293527b0f8677c9b461e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "yardi",
      "external_id": "80429594",
      "title": "Outdoor Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77649100fdd907bfa45acdc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "yardi",
      "external_id": "86392858",
      "title": "Package Acceptance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5afd9d1b66e69655ffa82f22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "yardi",
      "external_id": "80429595",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_546b4b910afe9a0316629b1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "yardi",
      "external_id": "82390292",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_93058e6521593bda5e5d17c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "yardi",
      "external_id": "82390294",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_efaa5c293e3dabd1669ac0eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "yardi",
      "external_id": "86392946",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b365996d82c2673d1302a8cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "yardi",
      "external_id": "80429603",
      "title": "In-Unit Washer And Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d42ad-4329-70fd-9779-cbae8430efa2.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with black stove and cabinets, open doorway to laundry area with Alexa sign.",
        "public_id": "019d42ad-4329-70fd-9779-cbae8430efa2",
        "storage_key": "property/6767906449166912/019d42ad-4329-70fd-9779-cbae8430efa2.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Sunstone Parc, Beaverton, OR, 97008, model kitchen and laundry area",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7cc84b92d95b318f8241b7f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "yardi",
      "external_id": "80429601",
      "title": "Additional Storage - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c611452196e85b67a986d055",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "yardi",
      "external_id": "80683677",
      "title": "Ceiling Fans - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4978-3158-7799-b238-c43b842e56a8.webp",
      "amenity_image_media": {
        "alt_text": "Dining area and kitchen with breakfast bar and bar stools",
        "public_id": "019d4978-3158-7799-b238-c43b842e56a8",
        "storage_key": "property/6767906449166912/019d4978-3158-7799-b238-c43b842e56a8.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Sunstone Parc, Beaverton, OR, 97008, model kitchen bar and dining room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_60a9c8462a3e1a4030563199",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "yardi",
      "external_id": "80683678",
      "title": "Curved Shower Bars - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d334b-2196-7700-b6fa-bdfa0193bed6.webp",
      "amenity_image_media": {
        "alt_text": "Modern bathroom with vanity, sink, toilet, and shower/tub combo.",
        "public_id": "019d334b-2196-7700-b6fa-bdfa0193bed6",
        "storage_key": "property/6767906449166912/019d334b-2196-7700-b6fa-bdfa0193bed6.webp",
        "width": 1463,
        "height": 2048
      },
      "amenity_image_alt_text": "Sunstone Parc, Beaverton, OR, 97008, model primary bathroom",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bb5174ec2d22e16f826572fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "yardi",
      "external_id": "89377874",
      "title": "Fireplace - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4978-3158-7799-b238-c20a6ff23a54.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a fireplace, large sectional sofa, dining table, and balcony access.",
        "public_id": "019d4978-3158-7799-b238-c20a6ff23a54",
        "storage_key": "property/6767906449166912/019d4978-3158-7799-b238-c20a6ff23a54.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Sunstone Parc, Beaverton, OR, 97008, model living room and fireplace",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1f4c242c31013ee8064b220d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "yardi",
      "external_id": "89377876",
      "title": "Private Patio - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cec5215355b9dbe9827d2dae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "yardi",
      "external_id": "89377878",
      "title": "Wetland View - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_43e72fd2559906101d8b791c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d42ad-4329-70fd-9779-cbae8430efa2.webp",
      "image_media": {
        "alt_text": "Kitchen with black stove and cabinets, open doorway to laundry area with Alexa sign.",
        "public_id": "019d42ad-4329-70fd-9779-cbae8430efa2",
        "storage_key": "property/6767906449166912/019d42ad-4329-70fd-9779-cbae8430efa2.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring a black stove, ample cabinet space, and a doorway leading to a laundry area adorned with a humorous \"Alexa, Do the laundry.\" sign.",
      "link": "false",
      "alt_text": "Kitchen with black stove and cabinets, open doorway to laundry area with Alexa sign.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_ModelKitchenLaundry.jpg"
    },
    {
      "id": "ec_03c61e871b82b8baccf7d598",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4978-3158-7799-b238-c43b842e56a8.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with breakfast bar and bar stools",
        "public_id": "019d4978-3158-7799-b238-c43b842e56a8",
        "storage_key": "property/6767906449166912/019d4978-3158-7799-b238-c43b842e56a8.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Enjoy a meal at the dining table or a quick bite at the breakfast bar in this open-concept kitchen and dining area. Features a full-sized refrigerator and ample counter space.",
      "link": "false",
      "alt_text": "Dining area and kitchen with breakfast bar and bar stools",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_ModelDiningRoom.jpg"
    },
    {
      "id": "ec_87f60165df3472a62c801304",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4978-314d-774d-80b9-6aca454ddd0d.webp",
      "image_media": {
        "alt_text": "Spacious living room with a large sectional sofa, coffee table, and TV.",
        "public_id": "019d4978-314d-774d-80b9-6aca454ddd0d",
        "storage_key": "property/6767906449166912/019d4978-314d-774d-80b9-6aca454ddd0d.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Enjoy this comfortable and stylish living room, perfect for relaxing or entertaining guests.",
      "link": "false",
      "alt_text": "Spacious living room with a large sectional sofa, coffee table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_ModelLivingRoomtoDiningRoom.jpg"
    },
    {
      "id": "ec_0d493ddc639c11ff1b93f4fe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4978-3153-7158-8b1d-33b46244ce83.webp",
      "image_media": {
        "alt_text": "Living room and dining area with sectional couch, dining table, and kitchen counter.",
        "public_id": "019d4978-3153-7158-8b1d-33b46244ce83",
        "storage_key": "property/6767906449166912/019d4978-3153-7158-8b1d-33b46244ce83.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with a comfortable sectional sofa, modern dining set, and a view into the kitchen. Perfect for entertaining.",
      "link": "false",
      "alt_text": "Living room and dining area with sectional couch, dining table, and kitchen counter.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_ModelLivingRoomSideView.jpg"
    },
    {
      "id": "ec_5fb4d7db0d2beb1161158146",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4978-3158-7799-b238-c20a6ff23a54.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, large sectional sofa, dining table, and balcony access.",
        "public_id": "019d4978-3158-7799-b238-c20a6ff23a54",
        "storage_key": "property/6767906449166912/019d4978-3158-7799-b238-c20a6ff23a54.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Cozy living area featuring a fireplace, comfortable seating, and a dining space, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room with a fireplace, large sectional sofa, dining table, and balcony access.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_ModelLivingRoomFireplace.jpg"
    },
    {
      "id": "ec_fd8023d5ace103483bb17e60",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4978-4020-7365-a1a3-82275b006a31.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, yellow and brown accent pillows, and a large plant.",
        "public_id": "019d4978-4020-7365-a1a3-82275b006a31",
        "storage_key": "property/6767906449166912/019d4978-4020-7365-a1a3-82275b006a31.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Relax and unwind in this inviting bedroom, featuring a comfortable queen-size bed, plush bedding, and elegant decor. Perfect for a restful night's sleep.",
      "link": "false",
      "alt_text": "Cozy bedroom with a queen-size bed, yellow and brown accent pillows, and a large plant.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_ModelPrimaryBedroom.jpg"
    },
    {
      "id": "ec_ed8b32ce3caa52d9551a99be",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4978-54da-75ac-9c5b-5049ee0063b6.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, yellow accents, and a large window.",
        "public_id": "019d4978-54da-75ac-9c5b-5049ee0063b6",
        "storage_key": "property/6767906449166912/019d4978-54da-75ac-9c5b-5049ee0063b6.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-size bed with bright yellow accents and a decorative wall piece. A large window provides ample natural light.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, yellow accents, and a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_ModelPrimaryBedroomWindows.jpg"
    },
    {
      "id": "ec_3f0f4eccdf73eb550314c3bb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4978-55ab-72d9-a01d-bb023a7ef8a7.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, yellow pillows, and a mirrored closet door reflecting the bed.",
        "public_id": "019d4978-55ab-72d9-a01d-bb023a7ef8a7",
        "storage_key": "property/6767906449166912/019d4978-55ab-72d9-a01d-bb023a7ef8a7.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed with accent pillows and a large mirrored closet, perfect for relaxation and style.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, yellow pillows, and a mirrored closet door reflecting the bed.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_ModelPrimaryBedroomCloset.jpg"
    },
    {
      "id": "ec_698377625d343df6ef4e5352",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d334b-2196-7700-b6fa-bdfa0193bed6.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, sink, toilet, and shower/tub combo.",
        "public_id": "019d334b-2196-7700-b6fa-bdfa0193bed6",
        "storage_key": "property/6767906449166912/019d334b-2196-7700-b6fa-bdfa0193bed6.webp",
        "width": 1463,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a vanity with sink, a toilet, and a bathtub with a shower.",
      "link": "false",
      "alt_text": "Modern bathroom with vanity, sink, toilet, and shower/tub combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_ModelPrimaryBathroom.jpg"
    },
    {
      "id": "ec_18181cf24b1f7485bbd1c3e7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4978-5984-77cb-90cd-89e0b273830d.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, Matisse art prints, and a laptop on a black fur throw.",
        "public_id": "019d4978-5984-77cb-90cd-89e0b273830d",
        "storage_key": "property/6767906449166912/019d4978-5984-77cb-90cd-89e0b273830d.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a plush queen-size bed adorned with white linens and decorative pillows. Matisse art prints and a laptop add a modern touch.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, Matisse art prints, and a laptop on a black fur throw.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_ModelSecondBedroom(1).jpg"
    },
    {
      "id": "ec_5450410ef3f46ff029787c7b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4978-5ca6-7235-829d-c94a635a0346.webp",
      "image_media": {
        "alt_text": "Bedroom with a large white bed, laptop on the bed, and a closet.",
        "public_id": "019d4978-5ca6-7235-829d-c94a635a0346",
        "storage_key": "property/6767906449166912/019d4978-5ca6-7235-829d-c94a635a0346.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed with plush pillows and a convenient closet for storage. A laptop sits on the bed, suggesting a space for work or relaxation.",
      "link": "false",
      "alt_text": "Bedroom with a large white bed, laptop on the bed, and a closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_ModelSecondBedroomCloset.jpg"
    },
    {
      "id": "ec_c96a997dbdbdd62e0c57fd78",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4978-61c2-76ea-a56c-490f3f0b0f7f.webp",
      "image_media": {
        "alt_text": "White bathtub with shower curtain, toilet, and vanity with sink in a bathroom.",
        "public_id": "019d4978-61c2-76ea-a56c-490f3f0b0f7f",
        "storage_key": "property/6767906449166912/019d4978-61c2-76ea-a56c-490f3f0b0f7f.webp",
        "width": 1463,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a white bathtub with shower curtain, toilet, and vanity with a sink. Modern finishes complement the clean design.",
      "link": "false",
      "alt_text": "White bathtub with shower curtain, toilet, and vanity with sink in a bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_ModelHallBathroom.jpg"
    },
    {
      "id": "ec_63e7e71ffb92691c1047cafd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4978-7415-7476-9d63-32f8b2d8a13e.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, a white refrigerator, and a black stove.",
        "public_id": "019d4978-7415-7476-9d63-32f8b2d8a13e",
        "storage_key": "property/6767906449166912/019d4978-7415-7476-9d63-32f8b2d8a13e.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen space featuring white cabinetry, a modern refrigerator, and a stove, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, a white refrigerator, and a black stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_1x1Kitchen.jpg"
    },
    {
      "id": "ec_313faa6880e29a41334cc8c8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b0-15b9-770e-9c9a-05b7b454f317.webp",
      "image_media": {
        "alt_text": "Sunstone Parc Apartment Homes monument sign with landscaping and flags",
        "public_id": "019d08b0-15b9-770e-9c9a-05b7b454f317",
        "storage_key": "property/6767906449166912/019d08b0-15b9-770e-9c9a-05b7b454f317.webp",
        "width": 900,
        "height": 600
      },
      "title": "Community",
      "description": "Welcome to Sunstone Parc Apartment Homes, a beautiful community with a well-maintained monument sign and lush landscaping.",
      "link": "false",
      "alt_text": "Sunstone Parc Apartment Homes monument sign with landscaping and flags",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_Monument01.jpg"
    },
    {
      "id": "ec_2ccf479b3ea481c2d55cffab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b0-1d0d-737a-85f4-0687399c84bd.webp",
      "image_media": {
        "alt_text": "Exterior building with balconies and staircases, surrounded by trees.",
        "public_id": "019d08b0-1d0d-737a-85f4-0687399c84bd",
        "storage_key": "property/6767906449166912/019d08b0-1d0d-737a-85f4-0687399c84bd.webp",
        "width": 900,
        "height": 600
      },
      "title": "Community",
      "description": "Exterior view of the apartment building, showcasing its architecture with balconies and external staircases, set amidst lush greenery.",
      "link": "false",
      "alt_text": "Exterior building with balconies and staircases, surrounded by trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_BuildingExterior01.jpg"
    },
    {
      "id": "ec_1fd26950f8c0237f172cfbec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b0-2283-7139-91fa-af5fc8a1eb53.webp",
      "image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and surrounding trees.",
        "public_id": "019d08b0-2283-7139-91fa-af5fc8a1eb53",
        "storage_key": "property/6767906449166912/019d08b0-2283-7139-91fa-af5fc8a1eb53.webp",
        "width": 900,
        "height": 600
      },
      "title": "Community",
      "description": "View the exterior of our apartment building, featuring balconies and lush green landscaping.",
      "link": "false",
      "alt_text": "Exterior view of an apartment building with balconies and surrounding trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_BuildingExterior02.jpg"
    },
    {
      "id": "ec_5613b0971f9aaef96c61dc10",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b0-2283-7139-91fa-b37d070d46ed.webp",
      "image_media": {
        "alt_text": "Building entrance with a covered walkway, decorative plants, and trees.",
        "public_id": "019d08b0-2283-7139-91fa-b37d070d46ed",
        "storage_key": "property/6767906449166912/019d08b0-2283-7139-91fa-b37d070d46ed.webp",
        "width": 900,
        "height": 600
      },
      "title": "Community",
      "description": "The welcoming entrance of the community features a covered walkway adorned with hanging flower baskets, lush landscaping, and mature trees, creating an inviting atmosphere.",
      "link": "false",
      "alt_text": "Building entrance with a covered walkway, decorative plants, and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_ClubhouseExterior.jpg"
    },
    {
      "id": "ec_6e1afb6e7ee19db73e77ee52",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019f4fc5-6d85-76b0-a743-a820c1dede8c.webp",
      "image_media": {
        "alt_text": "Interior view of a building entrance with seating and decor.",
        "public_id": "019f4fc5-6d85-76b0-a743-a820c1dede8c",
        "storage_key": "property/6767906449166912/019f4fc5-6d85-76b0-a743-a820c1dede8c.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Welcome guests into a beautifully appointed lobby area, featuring comfortable seating, and access to the outdoors.",
      "link": "false",
      "alt_text": "Interior view of a building entrance with seating and decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_LeasingOffice.jpg"
    },
    {
      "id": "ec_01a98fa0e21d449ce6e7f77b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019f4fc5-5907-718c-a9fe-a552b9997594.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with white sofa, green chairs, and island.",
        "public_id": "019f4fc5-5907-718c-a9fe-a552b9997594",
        "storage_key": "property/6767906449166912/019f4fc5-5907-718c-a9fe-a552b9997594.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Stylish open-concept living and dining area featuring a comfortable white sofa, modern green chairs, and a sleek kitchen island.",
      "link": "false",
      "alt_text": "Modern living room and kitchen area with white sofa, green chairs, and island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_ClubhouseLounge.jpg"
    },
    {
      "id": "ec_6baa8daebdb88236dc3d25fc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019f4fc5-6cd1-7135-9bc4-80c381bf27ef.webp",
      "image_media": {
        "alt_text": "Living room with a white sectional sofa, fireplace, and television.",
        "public_id": "019f4fc5-6cd1-7135-9bc4-80c381bf27ef",
        "storage_key": "property/6767906449166912/019f4fc5-6cd1-7135-9bc4-80c381bf27ef.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a comfortable sectional sofa, modern fireplace with a mounted TV, and stylish decor.",
      "link": "false",
      "alt_text": "Living room with a white sectional sofa, fireplace, and television.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_ClubhouseTV.jpg"
    },
    {
      "id": "ec_290ee44c70bdaa74328e425c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019f4fc5-6e4c-728a-a658-c2ca677f0ad5.webp",
      "image_media": {
        "alt_text": "Modern communal lounge area with a long high-top table, bar stools, fireplace, and a full kitchen.",
        "public_id": "019f4fc5-6e4c-728a-a658-c2ca677f0ad5",
        "storage_key": "property/6767906449166912/019f4fc5-6e4c-728a-a658-c2ca677f0ad5.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy the open-concept community lounge, complete with a fireplace, comfortable seating, and a fully equipped kitchen perfect for gatherings.",
      "link": "false",
      "alt_text": "Modern communal lounge area with a long high-top table, bar stools, fireplace, and a full kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_ClubhouseBarSeating.jpg"
    },
    {
      "id": "ec_983ad76b4db552c0311ba66d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019f4fc5-6d1d-716e-867a-33b59104859f.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019f4fc5-6d1d-716e-867a-33b59104859f",
        "storage_key": "property/6767906449166912/019f4fc5-6d1d-716e-867a-33b59104859f.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring stainless steel appliances including a dishwasher, microwave, and refrigerator. Granite countertops and a decorative backsplash add a touch of style.",
      "link": "false",
      "alt_text": "Kitchen with stainless steel appliances and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_ClubhouseKitchen.jpg"
    },
    {
      "id": "ec_8ead7ebbc3035c7d4667440d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019f4fc5-5c5c-74c7-8414-ef94224a70d2.webp",
      "image_media": {
        "alt_text": "Business center with computers, printers, and seating.",
        "public_id": "019f4fc5-5c5c-74c7-8414-ef94224a70d2",
        "storage_key": "property/6767906449166912/019f4fc5-5c5c-74c7-8414-ef94224a70d2.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Stay connected in our resident business center, fully equipped with computers and printing services for your convenience.",
      "link": "false",
      "alt_text": "Business center with computers, printers, and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_BusinessCenter(1).jpg"
    },
    {
      "id": "ec_ad87f150a058acad14f22430",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b0-3ec6-7227-a00c-6b5d12af1c08.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d08b0-3ec6-7227-a00c-6b5d12af1c08",
        "storage_key": "property/6767906449166912/019d08b0-3ec6-7227-a00c-6b5d12af1c08.webp",
        "width": 900,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush landscaping and comfortable lounge chairs.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_Pool01.jpg"
    },
    {
      "id": "ec_473307b8db8502862ead7a57",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4978-8c68-74fe-8195-7e3162fbf1cf.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "019d4978-8c68-74fe-8195-7e3162fbf1cf",
        "storage_key": "property/6767906449166912/019d4978-8c68-74fe-8195-7e3162fbf1cf.webp",
        "width": 1024,
        "height": 684
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by lush landscaping and comfortable seating. Perfect for relaxation and fun.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_Pool02.jpg"
    },
    {
      "id": "ec_f2bab5045fe6b7b09e8c1b8e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4978-7e45-7629-85fb-cc46d1c5269e.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills and ellipticals.",
        "public_id": "019d4978-7e45-7629-85fb-cc46d1c5269e",
        "storage_key": "property/6767906449166912/019d4978-7e45-7629-85fb-cc46d1c5269e.webp",
        "width": 480,
        "height": 640
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment like treadmills and ellipticals, perfect for your workout routine.",
      "link": "false",
      "alt_text": "Fitness center with treadmills and ellipticals.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_FitnessCenterCardio.jpg"
    },
    {
      "id": "ec_0433380254cba058c4a3f734",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4978-7ffe-769e-a81a-8ea758985365.webp",
      "image_media": {
        "alt_text": "Gym with exercise balls, weight bench, and dumbbells.",
        "public_id": "019d4978-7ffe-769e-a81a-8ea758985365",
        "storage_key": "property/6767906449166912/019d4978-7ffe-769e-a81a-8ea758985365.webp",
        "width": 480,
        "height": 640
      },
      "title": "Community",
      "description": "Workout in our community gym, featuring exercise balls, a weight bench, and a dumbbell rack for your fitness needs.",
      "link": "false",
      "alt_text": "Gym with exercise balls, weight bench, and dumbbells.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SunstoneParc_Beaverton_OR_FitnessCenterFreeWeights.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_9accdfb3-7e95-4f76-9b4e-2a5ad1875cf1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "9309 SW Washington Square Rd, Tigard, OR 97223, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "Diners say this restaurant offers a wide variety of dishes, including Bang Bang Chicken and Shrimp, cheesecake, and pasta, with many praising the extensive menu and delicious food. They also highlight the friendly and attentive service, and the vibrant and comfortable atmosphere.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-5722-7289-ad69-aa88a8e27598.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-5722-7289-ad69-aa88a8e27598",
        "storage_key": "property/6767906449166912/019d08b1-5722-7289-ad69-aa88a8e27598.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/or/tigard-101.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=9275120421759837335&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "45.4510321",
      "poi_longitude": "-122.7823753",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-620-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-090b-72db-bb04-f08ad2bafd90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-090b-72db-bb04-f08ad2bafd90",
        "storage_key": "property/6767906449166912/019d08b1-090b-72db-bb04-f08ad2bafd90.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6omzVcMlVQRl2T3w-HYt4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ed3ec184-f9cd-410d-9e31-0a8955e465a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Din Tai Fung",
      "poi_type": "Restaurants",
      "poi_address": "9724 SW Washington Square Rd, Tigard, OR 97223, USA",
      "poi_short_description": "Upscale eatery specializing in Taiwanese dumplings with soup, steamed dumplings, noodle dishes, fried rice and rice cakes.",
      "poi_long_description": "People say this Chinese restaurant serves delicious soup dumplings, garlic green beans, and noodles. They highlight the fast service and friendly staff. They also like the clean and modern atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-55f6-70aa-aaa8-39d442f42689.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-55f6-70aa-aaa8-39d442f42689",
        "storage_key": "property/6767906449166912/019d08b1-55f6-70aa-aaa8-39d442f42689.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://dtf.com/en/locations/tigard",
      "poi_directions_map_url": "https://maps.google.com/?cid=7925850032975282981&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "din-tai-fung",
      "poi_latitude": "45.4486876",
      "poi_longitude": "-122.7813741",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-768-9888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-090b-72db-bb04-f08ad2bafd90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-090b-72db-bb04-f08ad2bafd90",
        "storage_key": "property/6767906449166912/019d08b1-090b-72db-bb04-f08ad2bafd90.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJra5u8yENlVQRJYOCrpxG_m0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_34180cb2-63fb-4153-a5da-69fee9787de8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "10657 SW Beaverton Hillsdale Hwy, Beaverton, OR 97005, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches, nuggets, and waffle fries. They highlight the reasonable prices, convenient location, and ample parking. They also like the friendly staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-5625-7239-854f-049cd06e7c80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-5625-7239-854f-049cd06e7c80",
        "storage_key": "property/6767906449166912/019d08b1-5625-7239-854f-049cd06e7c80.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/or/raleigh-hills?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=16597217422825337868&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "45.4869133",
      "poi_longitude": "-122.7862333",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-305-9158",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-090b-72db-bb04-f08ad2bafd90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-090b-72db-bb04-f08ad2bafd90",
        "storage_key": "property/6767906449166912/019d08b1-090b-72db-bb04-f08ad2bafd90.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9onNxANlVQRDLRta08pVeY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_b8346a11-8956-47e1-a245-3a636252443d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "BGs Food Cartel",
      "poi_type": "Restaurants",
      "poi_address": "4250 SW Rose Biggi Ave, Beaverton, OR 97005, USA",
      "poi_short_description": "Open-air space with over 30 international food trucks, plus an indoor/outdoor speakeasy-style bar.",
      "poi_long_description": "People say this restaurant offers tasty brisket, pork fried rice, and potstickers. They highlight the generous portions, the variety of food trucks, and the family-friendly atmosphere with a kids' play area and ample seating. They also like the clean restrooms and convenient parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b0-6c32-72c9-a5f1-1dcfee084ede.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-6c32-72c9-a5f1-1dcfee084ede",
        "storage_key": "property/6767906449166912/019d08b0-6c32-72c9-a5f1-1dcfee084ede.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bgfoodcartel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13359900484536572783&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bgs-food-cartel",
      "poi_latitude": "45.4892645",
      "poi_longitude": "-122.8081145",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-605-9163",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-090b-72db-bb04-f08ad2bafd90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-090b-72db-bb04-f08ad2bafd90",
        "storage_key": "property/6767906449166912/019d08b1-090b-72db-bb04-f08ad2bafd90.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJSQIYZ8OlVQRbxtf97TmZ7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_9e87d0c0-4730-44ed-9614-4e5d123dd7eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Dave's Hot Chicken",
      "poi_type": "Restaurants",
      "poi_address": "2545 SW Cedar Hills Blvd Suite 100, Beaverton, OR 97005, USA",
      "poi_short_description": "Counter-serve chain known for its sliders, fries, and Nashville hot chicken dishes.",
      "poi_long_description": "People say this chicken restaurant serves delicious chicken sliders, tenders, and crinkle-cut fries, with a variety of spice levels to choose from. They highlight the generous portions, especially the sliders, and the tasty sauce, pickles, and slaw. They also like the friendly and welcoming staff, and the quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-5924-72cd-9ce6-2ae9c2f93773.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-5924-72cd-9ce6-2ae9c2f93773",
        "storage_key": "property/6767906449166912/019d08b1-5924-72cd-9ce6-2ae9c2f93773.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.daveshotchicken.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6237597429948200291&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "daves-hot-chicken",
      "poi_latitude": "45.5015232",
      "poi_longitude": "-122.8071683",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 971-348-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-090b-72db-bb04-f08ad2bafd90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-090b-72db-bb04-f08ad2bafd90",
        "storage_key": "property/6767906449166912/019d08b1-090b-72db-bb04-f08ad2bafd90.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdd2vb-UPlVQRY7Xzd9BlkFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_810611b4-b1cc-4533-961f-0fda6efda4c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Washington Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "9585 SW Washington Square Rd, Portland, OR 97223, USA",
      "poi_short_description": "Large shopping center with a variety of department stores, specialty shops & food options.",
      "poi_long_description": "People say this shopping center offers a wide selection of shops, restaurants, and services, including a Cheesecake Factory, a Lego store, and a variety of clothing stores. They also highlight the clean and well-maintained environment, the friendly and helpful staff, and the convenient parking.\n\nOther reviews mention the food court can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b0-91eb-71ab-b6e2-5f9e5a5eeeb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-91eb-71ab-b6e2-5f9e5a5eeeb5",
        "storage_key": "property/6767906449166912/019d08b0-91eb-71ab-b6e2-5f9e5a5eeeb5.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.shopwashingtonsquare.com/?utm_source=google&utm_medium=onlinesearch&utm_content=gmp_website_button&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=8036230870585529003&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "washington-square",
      "poi_latitude": "45.4502491",
      "poi_longitude": "-122.7812183",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-639-8860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-0922-73ff-ab30-53140b436012.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0922-73ff-ab30-53140b436012",
        "storage_key": "property/6767906449166912/019d08b1-0922-73ff-ab30-53140b436012.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJy9M2zVcMlVQRq1JHJmZthm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_ad9e9ded-d04a-430f-aa0d-812da9eea0b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Uwajimaya Beaverton",
      "poi_type": "Shopping & Retail",
      "poi_address": "10500 SW Beaverton Hillsdale Hwy, Beaverton, OR 97005, USA",
      "poi_short_description": "Perennial Asian grocery stocking meats, produce & prepared foods, plus gifts & home goods.",
      "poi_long_description": "People say this Asian grocery store offers a wide selection of fresh seafood, produce, and Japanese groceries, including musubi, onigiri, and poke. They highlight the friendly and helpful staff, and the fun, unique shopping experience. They also like the bookstore in the back and the delicious hot food options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-5d9b-710c-b56d-ddfa1c8eadc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-5d9b-710c-b56d-ddfa1c8eadc2",
        "storage_key": "property/6767906449166912/019d08b1-5d9b-710c-b56d-ddfa1c8eadc2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.uwajimaya.com/visit/beaverton/?utm_source=localprofiles&utm_medium=organic&utm_content=beaverton&utm_campaign=fm",
      "poi_directions_map_url": "https://maps.google.com/?cid=6570527899701517362&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uwajimaya-beaverton",
      "poi_latitude": "45.48564529999999",
      "poi_longitude": "-122.7849074",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 503-643-4512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-0916-7782-adc4-8aac7921b6df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0916-7782-adc4-8aac7921b6df",
        "storage_key": "property/6767906449166912/019d08b1-0916-7782-adc4-8aac7921b6df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiVB9wAQMlVQRMpyACFA0L1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_e356de54-36ba-4cb1-b828-75e1bf67ebc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Bridgeport Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "7455 SW Bridgeport Rd, Tigard, OR 97224, USA",
      "poi_short_description": "Outdoor shopping complex featuring entertainment, high-end retailers & sit-down & casual dining.",
      "poi_long_description": "People say this shopping center offers a wide selection of shops, restaurants, and a movie theater. They also highlight the clean, beautiful, and open-air atmosphere, as well as the friendly staff.\n\nOther reviews mention the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-5df9-772e-a49a-ab7a420f2f40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-5df9-772e-a49a-ab7a420f2f40",
        "storage_key": "property/6767906449166912/019d08b1-5df9-772e-a49a-ab7a420f2f40.webp",
        "width": 1280,
        "height": 484
      },
      "poi_business_url": "https://www.bridgeport-village.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2515733834919836986&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bridgeport-village",
      "poi_latitude": "45.3957237",
      "poi_longitude": "-122.7528244",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-968-1704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-0922-73ff-ab30-53140b436012.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0922-73ff-ab30-53140b436012",
        "storage_key": "property/6767906449166912/019d08b1-0922-73ff-ab30-53140b436012.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnYnrbetylVQROv3TC5iu6SI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_ccf33589-6fb5-4ca9-8eef-b227c04dd3e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Columbia Sportswear Company Employee Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "14100 NW Science Park Dr, Portland, OR 97229, USA",
      "poi_short_description": "Spacious shop carrying jackets, hoodies and other mountain-ready pieces from Patagonia, Sorel and prAna.",
      "poi_long_description": "People say this sportswear store offers a wide selection of products from brands like Columbia, Mountain Hardwear, and Sorel. They highlight the great deals and discounts, especially for those with employee access, and the clean, well-organized layout. They also like the friendly, helpful, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-5f2f-71b2-8ab4-0f43e5f98ee0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-5f2f-71b2-8ab4-0f43e5f98ee0",
        "storage_key": "property/6767906449166912/019d08b1-5f2f-71b2-8ab4-0f43e5f98ee0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.columbia.com/or/portland/employee-store-425",
      "poi_directions_map_url": "https://maps.google.com/?cid=2313366469886134804&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "columbia-sportswear-company-employee-store",
      "poi_latitude": "45.5261922",
      "poi_longitude": "-122.8234194",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-985-4125",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-0922-73ff-ab30-53140b436012.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0922-73ff-ab30-53140b436012",
        "storage_key": "property/6767906449166912/019d08b1-0922-73ff-ab30-53140b436012.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbxyE2yoPlVQRFMrcMIy6GiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_cf513f01-0f35-4e55-b8b0-33173f9a35ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "3025 SW Cedar Hills Blvd, Beaverton, OR 97005, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide selection of groceries, including a large bulk section, and fresh produce. They also highlight the affordable prices, convenient 24-hour service, and friendly staff.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-5fb5-76ca-a4db-856155c47eda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-5fb5-76ca-a4db-856155c47eda",
        "storage_key": "property/6767906449166912/019d08b1-5fb5-76ca-a4db-856155c47eda.webp",
        "width": 1280,
        "height": 744
      },
      "poi_business_url": "http://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15287079724831147658&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "45.49809399999999",
      "poi_longitude": "-122.810114",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-644-4940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-0916-7782-adc4-8aac7921b6df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0916-7782-adc4-8aac7921b6df",
        "storage_key": "property/6767906449166912/019d08b1-0916-7782-adc4-8aac7921b6df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk19IebsOlVQRigaj6wOeJtQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_237e68bf-9922-43f1-8882-f21e6b861195",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Portland Community College Sylvania",
      "poi_type": "Education",
      "poi_address": "12000 SW 49th Ave, Portland, OR 97219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b0-aac8-751d-93fa-fa6b8c584921.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-aac8-751d-93fa-fa6b8c584921",
        "storage_key": "property/6767906449166912/019d08b0-aac8-751d-93fa-fa6b8c584921.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.pcc.edu/about/locations/sylvania/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6662908794779881992&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "portland-community-college-sylvania",
      "poi_latitude": "45.4377659",
      "poi_longitude": "-122.7307089",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 971-722-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-0fc7-739e-a572-c022f4dfe37b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0fc7-739e-a572-c022f4dfe37b",
        "storage_key": "property/6767906449166912/019d08b1-0fc7-739e-a572-c022f4dfe37b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUfp1OLoMlVQRCFKuSz9od1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_aecea096-c328-4c2e-932c-a72a1ef281e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Beaverton City Library",
      "poi_type": "Education",
      "poi_address": "12375 SW 5th St, Beaverton, OR 97005, USA",
      "poi_short_description": "Multistory library with kids' areas, computers and board game rentals.",
      "poi_long_description": "People say this public library offers a wide selection of books, music CDs, DVDs/Blu-rays, and video games, as well as digital resources and a \"Library of Things.\" They highlight the spacious layout, beautiful architecture, and numerous working, studying, and reading spaces, including a dedicated children's area with storytime rooms. They also like the friendly and helpful staff, and the various activities and events for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-6430-7458-b3c8-4fa9460596c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-6430-7458-b3c8-4fa9460596c8",
        "storage_key": "property/6767906449166912/019d08b1-6430-7458-b3c8-4fa9460596c8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://beavertonlibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2456838086164544331&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beaverton-city-library",
      "poi_latitude": "45.4840984",
      "poi_longitude": "-122.804071",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-644-2197",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-0fc7-739e-a572-c022f4dfe37b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-0fc7-739e-a572-c022f4dfe37b",
        "storage_key": "property/6767906449166912/019d08b1-0fc7-739e-a572-c022f4dfe37b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv_YnSyAMlVQRS_t89DhxGCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_a5e9bc59-76d1-4221-963b-467c0a4c33a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Oregon Zoo",
      "poi_type": "Entertainment",
      "poi_address": "4001 SW Canyon Rd, Portland, OR 97221, USA",
      "poi_short_description": "64-acre zoo featuring elephants, polar bears & other animal exhibits emphasizing conservation.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including elephants, polar bears, giraffes, and lions, and features a popular baby elephant. They highlight the well-maintained exhibits, the spacious and natural habitats, and the fun train ride. They also like the family-friendly atmosphere and the knowledgeable staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-65bd-726f-902a-1ee0d44e27ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-65bd-726f-902a-1ee0d44e27ba",
        "storage_key": "property/6767906449166912/019d08b1-65bd-726f-902a-1ee0d44e27ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.oregonzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16710360885333195814&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oregon-zoo",
      "poi_latitude": "45.5093572",
      "poi_longitude": "-122.714291",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-226-1561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1540-76f2-9455-b0186f7cdd92",
        "storage_key": "property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBbhWuC4KlVQRJvzdnrAg5-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_cab02411-d460-4c55-b983-7b76e4f287bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "World Forestry Center",
      "poi_type": "Entertainment",
      "poi_address": "4033 SW Canyon Rd, Portland, OR 97221, USA",
      "poi_short_description": "Hands-on exhibits are designed to teach visitors about the sustainability of forests & trees.",
      "poi_long_description": "People say this museum offers interactive exhibits that are engaging for all ages. They highlight the beautiful aesthetics, the large arboretum with walking paths, and the fun gift shop. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-65b3-7481-a4a9-9cad8e57bfb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-65b3-7481-a4a9-9cad8e57bfb1",
        "storage_key": "property/6767906449166912/019d08b1-65b3-7481-a4a9-9cad8e57bfb1.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://www.worldforestry.org/?utm_source=google-gmb-maps&utm_medium=gmb-website-button&utm_campaign=locl.io&utm_content=d3cc9171-0344-4c94-a6bc-d319f701006d",
      "poi_directions_map_url": "https://maps.google.com/?cid=6725323115738335161&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "world-forestry-center",
      "poi_latitude": "45.5106895",
      "poi_longitude": "-122.7180284",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-228-1367",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-16af-7625-a11f-44cabbab2dfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-16af-7625-a11f-44cabbab2dfe",
        "storage_key": "property/6767906449166912/019d08b1-16af-7625-a11f-44cabbab2dfe.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgzHm2SsKlVQRuYdO0b0lVV0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_14c6960a-bc7c-4a64-9a05-c2f8444777c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Fogelbo Historic Log Home",
      "poi_type": "Entertainment",
      "poi_address": "Portland, OR 97223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-6b15-77b3-a15d-3805274d35c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-6b15-77b3-a15d-3805274d35c9",
        "storage_key": "property/6767906449166912/019d08b1-6b15-77b3-a15d-3805274d35c9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.nordicnorthwest.org/fogelbo",
      "poi_directions_map_url": "https://maps.google.com/?cid=11192867665588144266&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fogelbo-historic-log-home",
      "poi_latitude": "45.4566478",
      "poi_longitude": "-122.7666597",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-977-0275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1540-76f2-9455-b0186f7cdd92",
        "storage_key": "property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb3ptVvUMlVQRikhW6dYNVZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_517d7f88-3e6c-4003-9b79-13975cf2438c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Aubrey Watzek House",
      "poi_type": "Entertainment",
      "poi_address": "1061 SW Skyline Blvd, Portland, OR 97221, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-6c96-721f-90de-16a6efc0b4ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-6c96-721f-90de-16a6efc0b4ee",
        "storage_key": "property/6767906449166912/019d08b1-6c96-721f-90de-16a6efc0b4ee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://yeoncenter.uoregon.edu/our-locations/the-watzek-house/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12365212951832866477&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aubrey-watzek-house",
      "poi_latitude": "45.5151945",
      "poi_longitude": "-122.7279731",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-241-2886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1540-76f2-9455-b0186f7cdd92",
        "storage_key": "property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFSh9n4EJlVQRra4OfqoPmqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_df51af0f-853e-4c4c-88d2-7649bf4cd6ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "600 SW 116th Ave, Portland, OR 97225, USA",
      "poi_short_description": "Athletic country club chain in Cedar Mill with a gym, an outdoor beach club, pools, basketball and pickleball courts, and a sauna.",
      "poi_long_description": "People say this gym offers a wide variety of classes, top-notch equipment, and multiple pools, including an adults-only option, and provides convenient amenities like a cafe, lounge, and clean locker rooms with saunas and plunge pools.\n\nOther reviews mention the price can be high and the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-6c21-72d0-b385-74587a79487f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-6c21-72d0-b385-74587a79487f",
        "storage_key": "property/6767906449166912/019d08b1-6c21-72d0-b385-74587a79487f.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/or/beaverton.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=8291423413939196135&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "45.5153662",
      "poi_longitude": "-122.7940413",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-616-9950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1540-76f2-9455-b0186f7cdd92",
        "storage_key": "property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ88xwwvQJlVQR59AzRqoNEXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_661f4b5a-e52b-46be-8dc2-fc5b6392391a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Villa Sport Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "13900 SW Meridian St, Beaverton, OR 97005, USA",
      "poi_short_description": "Large, resort-like, family-oriented recreation center featuring a gym, plus numerous clean pools (indoors and out), a hot tub and a sauna.",
      "poi_long_description": "People say this gym offers a variety of pools, fitness classes, and amenities, including a steam room, sauna, and hot tubs. They also highlight the family-friendly vibe, the dedicated instructors, and the welcoming staff.\n\nOther reviews mention the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b0-c650-7598-bb19-8caf33673baf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-c650-7598-bb19-8caf33673baf",
        "storage_key": "property/6767906449166912/019d08b0-c650-7598-bb19-8caf33673baf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.villasport.com/beaverton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6712726625660967216&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "villa-sport-athletic-club",
      "poi_latitude": "45.5039949",
      "poi_longitude": "-122.8247248",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 971-317-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1540-76f2-9455-b0186f7cdd92",
        "storage_key": "property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaSSIqMEOlVQRMBnU7ExlKF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_16f66385-692e-4f47-9d73-6a3b3973db87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "17942 SW McEwan Rd, Tigard, OR 97224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-720b-72ab-9330-af95e1f4d5fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-720b-72ab-9330-af95e1f4d5fa",
        "storage_key": "property/6767906449166912/019d08b1-720b-72ab-9330-af95e1f4d5fa.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/tigard-or/tualatin-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=709569765366759855&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "45.3942716",
      "poi_longitude": "-122.7437279",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-670-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1540-76f2-9455-b0186f7cdd92",
        "storage_key": "property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0jwLe9ylVQRrwELMPHl2Ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6a7100b4-0015-4d5b-9139-7b26d0c2bd43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2800 SW Hocken Ave, Beaverton, OR 97005, USA",
      "poi_short_description": "Chain offering treadmills, swimming pools. basketball courts and strength equipment.",
      "poi_long_description": "People say this gym offers a pool and swim aerobic classes.\n\nOther reviews mention the facility can be poorly maintained and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b0-c4ec-70a2-b5ef-33321940f357.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-c4ec-70a2-b5ef-33321940f357",
        "storage_key": "property/6767906449166912/019d08b0-c4ec-70a2-b5ef-33321940f357.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=324&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12600149306380626618&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "45.4994817",
      "poi_longitude": "-122.8128318",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-627-0737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1540-76f2-9455-b0186f7cdd92",
        "storage_key": "property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0dUPA7wOlVQRuqqzIwm53K4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9cecf947-024c-4c87-bc47-5609a7ea17f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7255 SW Dartmouth St, Tigard, OR 97223, USA",
      "poi_short_description": "Nationwide gym chain with an inclusive vibe offering massage chairs and tanning beds.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained machines, free weights, and cardio equipment, as well as amenities like tanning, massage chairs, and a wellness pod. They highlight the affordable membership options, convenient location, and clean facilities, including spacious locker rooms with built-in locks. They also like the friendly, helpful, and efficient staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-71e5-74fc-b46d-7b85c2342415.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-71e5-74fc-b46d-7b85c2342415",
        "storage_key": "property/6767906449166912/019d08b1-71e5-74fc-b46d-7b85c2342415.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/tigard-tigard-triangle-or?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1183844742547254266&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "45.43372249999999",
      "poi_longitude": "-122.7517173",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 503-746-6489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1540-76f2-9455-b0186f7cdd92",
        "storage_key": "property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcb1JzYwNlVQR-iu-ZIXcbRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ef5f14e1-0192-4efd-809a-7265badedda2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "3255 SW Cedar Hills Blvd #150, Beaverton, OR 97005, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-7776-722a-9bbb-827c1bb350b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-7776-722a-9bbb-827c1bb350b8",
        "storage_key": "property/6767906449166912/019d08b1-7776-722a-9bbb-827c1bb350b8.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/beaverton-or-188",
      "poi_directions_map_url": "https://maps.google.com/?cid=18015545214605731550&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "45.4959133",
      "poi_longitude": "-122.8109335",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-643-7080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1540-76f2-9455-b0186f7cdd92",
        "storage_key": "property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW-pEp7wOlVQR3iaQF-wSBPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_d286671a-f8d7-4477-8fc9-4fd95c511c60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Providence St. Vincent Hospital East Pavilion",
      "poi_type": "Health and Wellness",
      "poi_address": "9155 SW Barnes Rd, Portland, OR 97225, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-798a-7109-9807-58bd43b87292.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-798a-7109-9807-58bd43b87292",
        "storage_key": "property/6767906449166912/019d08b1-798a-7109-9807-58bd43b87292.webp",
        "width": 1280,
        "height": 815
      },
      "poi_business_url": "https://oregon.providence.org/location-directory/p/providence-st-vincent-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5100053104868075598&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "providence-st-vincent-hospital-east-pavilion",
      "poi_latitude": "45.510411",
      "poi_longitude": "-122.7701193",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-216-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1ab5-7508-a775-6561d0851743.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1ab5-7508-a775-6561d0851743",
        "storage_key": "property/6767906449166912/019d08b1-1ab5-7508-a775-6561d0851743.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJtQXvYkMJlVQRTihKE0cHx0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1ef88172-6c94-4fab-8106-6c7a16e92a68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Providence St. Vincent Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "9205 SW Barnes Rd, Portland, OR 97225, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b0-b9ae-745a-b6f9-86f4503ba49b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-b9ae-745a-b6f9-86f4503ba49b",
        "storage_key": "property/6767906449166912/019d08b0-b9ae-745a-b6f9-86f4503ba49b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.providence.org/locations/or/st-vincent-medical-center?ls=location&y_source=1_OTU3NjM5Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1736548786178364168&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "providence-st-vincent-medical-center",
      "poi_latitude": "45.5103299",
      "poi_longitude": "-122.7720125",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-216-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1ab5-7508-a775-6561d0851743.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1ab5-7508-a775-6561d0851743",
        "storage_key": "property/6767906449166912/019d08b1-1ab5-7508-a775-6561d0851743.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1QPVf0QJlVQRCBNMn-t1GRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_54d85dcc-a088-472e-b493-a5e7413d01fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Cook Family Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17005 SW 92nd Ave, Tigard, OR 97224, USA",
      "poi_short_description": "Riverside park offering various sports & picnic areas, as well as a playground & a boat ramp.",
      "poi_long_description": "People say this city park offers a playground, walking trails, picnic tables, and a kayak launch. They highlight the park is clean, spacious, and family-friendly, with plenty of parking and restrooms. They also like the beautiful river views and opportunities for kayaking, canoeing, and paddleboarding.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-7bd7-712e-94ec-55e5132f496d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-7bd7-712e-94ec-55e5132f496d",
        "storage_key": "property/6767906449166912/019d08b1-7bd7-712e-94ec-55e5132f496d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tigard-or.gov/Home/Components/FacilityDirectory/FacilityDirectory/143/181",
      "poi_directions_map_url": "https://maps.google.com/?cid=17281400391354763777&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cook-family-park",
      "poi_latitude": "45.39603959999999",
      "poi_longitude": "-122.771663",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-718-2591",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1542-70af-9783-7814356357a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1542-70af-9783-7814356357a5",
        "storage_key": "property/6767906449166912/019d08b1-1542-70af-9783-7814356357a5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA_XlT7xylVQRAUr_Wxje0-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5444f67f-5253-491c-ab01-72b0c7fcb26f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "RedTail Golf Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8200 SW Scholls Ferry Rd, Beaverton, OR 97008, USA",
      "poi_short_description": "Golf center at an 18-hole course offering practice facilities, lessons, a pro shop & an eatery.",
      "poi_long_description": "People say this golf course offers a well-stocked pro shop, a driving range with TrackMan technology, and professional lessons. They also highlight the friendly and helpful staff, and the quick turnaround for services like regripping.\n\nOther reviews mention the course can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-7b48-72b2-b93f-f7ab1d520487.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-7b48-72b2-b93f-f7ab1d520487",
        "storage_key": "property/6767906449166912/019d08b1-7b48-72b2-b93f-f7ab1d520487.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://golfredtail.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15748737038652720950&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "redtail-golf-center",
      "poi_latitude": "45.4608887",
      "poi_longitude": "-122.778375",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-646-5166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-9ed9-77d9-8296-e0719031aae3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-9ed9-77d9-8296-e0719031aae3",
        "storage_key": "property/6767906449166912/019d08b1-9ed9-77d9-8296-e0719031aae3.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJTYBlhF4MlVQRNsfuceXAjto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_facb6fa7-672f-47d9-a361-8da8d8fccd6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Gabriel Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "SW 45th Ave & Vermont Street, Portland, OR 97219, USA",
      "poi_short_description": "91-acre space with amenities including skate park, off-leash dog area, tennis court & sports fields.",
      "poi_long_description": "Visitors say this city park offers a spacious dog park, a well-equipped playground with a cool slide and trampoline, and a water feature. They also highlight the extensive trails, perfect for walking, biking, and enjoying nature, as well as the skate park and numerous sports courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-7dbd-76d0-af68-0edd0cc675a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-7dbd-76d0-af68-0edd0cc675a5",
        "storage_key": "property/6767906449166912/019d08b1-7dbd-76d0-af68-0edd0cc675a5.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.portlandoregon.gov/parks/finder/index.cfm?propertyid=136&action=ViewPark",
      "poi_directions_map_url": "https://maps.google.com/?cid=8816564431343279027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gabriel-park",
      "poi_latitude": "45.474297",
      "poi_longitude": "-122.7191089",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-823-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1542-70af-9783-7814356357a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1542-70af-9783-7814356357a5",
        "storage_key": "property/6767906449166912/019d08b1-1542-70af-9783-7814356357a5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQb4pLp4LlVQRs1uPXaO6Wno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c8f351f6-3e00-409b-b81f-b1f732e9a387",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Tryon Creek State Natural Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Portland, OR, USA",
      "poi_short_description": "658-acre forested area along a ravine with well-maintained trails for hikers, horses & leashed dogs.",
      "poi_long_description": "People say this state park offers a variety of hiking trails, bridges, and a nature center. They highlight the well-maintained paths, beautiful forest scenery, and opportunities for bird watching and wildlife viewing. They also like the friendly and helpful staff, and the availability of maps and restrooms at the visitor center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-81ac-7047-81ab-5f251ef54b96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-81ac-7047-81ab-5f251ef54b96",
        "storage_key": "property/6767906449166912/019d08b1-81ac-7047-81ab-5f251ef54b96.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://oregonstateparks.org/index.cfm?do=parkPage.dsp_parkPage&parkId=103",
      "poi_directions_map_url": "https://maps.google.com/?cid=1610167000461447853&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tryon-creek-state-natural-area",
      "poi_latitude": "45.4377277",
      "poi_longitude": "-122.6770448",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 800-551-6949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1542-70af-9783-7814356357a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1542-70af-9783-7814356357a5",
        "storage_key": "property/6767906449166912/019d08b1-1542-70af-9783-7814356357a5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJa9n8LTQLlVQRrZKPG1t2WBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_a2fcc9ec-1d69-42c4-a320-4c405ef94a8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Tualatin Hills Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15655 SW Millikan Way, Beaverton, OR 97006, USA",
      "poi_short_description": "Hiking & biking trails along with playgrounds & sports facilities in a family-friendly public park.",
      "poi_long_description": "People say this park offers a variety of trails, including paved, unpaved, and boardwalk options, and is a great place to see birds and other wildlife. They highlight the well-maintained trails, clean restrooms, and the abundance of shade provided by the trees. They also like the interactive visitor center and the peaceful, rejuvenating atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b0-aacc-72dd-9f29-116af74d3a29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-aacc-72dd-9f29-116af74d3a29",
        "storage_key": "property/6767906449166912/019d08b0-aacc-72dd-9f29-116af74d3a29.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thprd.org/parks-and-trails/detail/tualatin-hills-nature-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17581483943034553182&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tualatin-hills-nature-park",
      "poi_latitude": "45.4982312",
      "poi_longitude": "-122.8396247",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-645-6433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1542-70af-9783-7814356357a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1542-70af-9783-7814356357a5",
        "storage_key": "property/6767906449166912/019d08b1-1542-70af-9783-7814356357a5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWfj9vvMOlVQRXgPP2H76_fM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6be51909-c944-45fa-8450-ffeae925a35b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Beaverton TC MAX Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97005, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-841d-7571-81f6-7c908e142f02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-841d-7571-81f6-7c908e142f02",
        "storage_key": "property/6767906449166912/019d08b1-841d-7571-81f6-7c908e142f02.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://trimet.org/ride/stop.html?id=9821",
      "poi_directions_map_url": "https://maps.google.com/?cid=13913915888813031590&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beaverton-tc-max-station",
      "poi_latitude": "45.4914575",
      "poi_longitude": "-122.8016546",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1540-76f2-9455-b0186f7cdd92",
        "storage_key": "property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnQ7Mt6YOlVQRpkBdI8goGME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_39abacaa-155b-46a5-8066-1dafad1ff4ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Elmonica/SW 170th Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b0-e283-764c-8cb7-ce45ec582ad8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-e283-764c-8cb7-ce45ec582ad8",
        "storage_key": "property/6767906449166912/019d08b0-e283-764c-8cb7-ce45ec582ad8.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://trimet.org/ride/stop.html?id=9829",
      "poi_directions_map_url": "https://maps.google.com/?cid=12242366764481047543&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elmonicasw-170th-ave",
      "poi_latitude": "45.5099231",
      "poi_longitude": "-122.8515139",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1540-76f2-9455-b0186f7cdd92",
        "storage_key": "property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-c6QOOMOlVQR9-vwnrWf5ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_a1ea9a1d-a964-4801-a591-227cfeacc9bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Millikan Way",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97005, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-865e-77ea-96cd-073a319ac8f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-865e-77ea-96cd-073a319ac8f2",
        "storage_key": "property/6767906449166912/019d08b1-865e-77ea-96cd-073a319ac8f2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://trimet.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14285898637418825828&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "millikan-way",
      "poi_latitude": "45.49523019999999",
      "poi_longitude": "-122.8216184",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1540-76f2-9455-b0186f7cdd92",
        "storage_key": "property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0Zr7ZYOlVQRZAiW7B61QcY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_701a1ca5-9bc5-4fad-bc70-6a6565388b80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Sunset TC Eastbound",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97225, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-8792-777b-aebc-567a0bbe138c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-8792-777b-aebc-567a0bbe138c",
        "storage_key": "property/6767906449166912/019d08b1-8792-777b-aebc-567a0bbe138c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12905581304195677897&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sunset-tc-eastbound",
      "poi_latitude": "45.51024",
      "poi_longitude": "-122.78103",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1540-76f2-9455-b0186f7cdd92",
        "storage_key": "property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh1_xq0gJlVQRyX6ByNHVGbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_e3c954f2-c9d3-4d0c-b6d3-5abeb9f75f13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Beaverton Creek",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-88ee-7191-89f4-d4e9ad57ae3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-88ee-7191-89f4-d4e9ad57ae3c",
        "storage_key": "property/6767906449166912/019d08b1-88ee-7191-89f4-d4e9ad57ae3c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://trimet.org/ride/stop.html?stop_id=9822",
      "poi_directions_map_url": "https://maps.google.com/?cid=9246488210937445740&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beaverton-creek",
      "poi_latitude": "45.500417",
      "poi_longitude": "-122.833055",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1540-76f2-9455-b0186f7cdd92",
        "storage_key": "property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4YGUjuwOlVQRbH3DsAkgUoA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_21e77ccf-24db-4bf9-b061-6eb069cec2d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Nike World Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One Bowerman Dr, Beaverton, OR 97005, USA",
      "poi_short_description": "Chain retailer selling a range of Nike athletic footwear, apparel & accessories for adults & kids.",
      "poi_long_description": "Chain retailer selling a range of Nike athletic footwear, apparel & accessories for adults & kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-8baf-76c5-b727-78d8d95465ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-8baf-76c5-b727-78d8d95465ea",
        "storage_key": "property/6767906449166912/019d08b1-8baf-76c5-b727-78d8d95465ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://about.nike.com/pages/contact-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=12026902182619501264&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nike-world-headquarters",
      "poi_latitude": "45.5075349",
      "poi_longitude": "-122.8272752",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-671-6453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1540-76f2-9455-b0186f7cdd92",
        "storage_key": "property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbaRNTcIOlVQR0NJnV9Aj6KY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1d39ca24-d73f-413f-bdb8-675b08c4dfdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Lam Research",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11355 SW Leveton Dr, Tualatin, OR 97062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-8d51-72ce-bb1e-f58fa69919f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-8d51-72ce-bb1e-f58fa69919f5",
        "storage_key": "property/6767906449166912/019d08b1-8d51-72ce-bb1e-f58fa69919f5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lamresearch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8683645162624889977&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lam-research",
      "poi_latitude": "45.38651220000001",
      "poi_longitude": "-122.7923427",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-685-8345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1540-76f2-9455-b0186f7cdd92",
        "storage_key": "property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU_cRBl5tlVQRebTLeUSBgng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_026445e8-e7ec-44ad-9bc5-a7bab0e54e27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Intel Aloha Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3585 SW 198th Ave, Aloha, OR 97007, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-8eb4-7478-801f-0a92dbc2fc99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-8eb4-7478-801f-0a92dbc2fc99",
        "storage_key": "property/6767906449166912/019d08b1-8eb4-7478-801f-0a92dbc2fc99.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.intel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14108862077939276750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intel-aloha-campus",
      "poi_latitude": "45.4932457",
      "poi_longitude": "-122.8830336",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 971-215-0582",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1540-76f2-9455-b0186f7cdd92",
        "storage_key": "property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJle0AW0gOlVQRztuM1E6_zMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_fe04209e-7801-4ad7-906a-cc2b6776c025",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Nike - Lebron James",
      "poi_type": "Major Employers & Offices",
      "poi_address": "15050 SW Koll Pkwy, Beaverton, OR 97006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-9068-75d9-b7ac-d5de12f9470f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-9068-75d9-b7ac-d5de12f9470f",
        "storage_key": "property/6767906449166912/019d08b1-9068-75d9-b7ac-d5de12f9470f.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://lebronjamesinnovationcenter.nike.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15961945776638885973&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nike---lebron-james",
      "poi_latitude": "45.51239169999999",
      "poi_longitude": "-122.8311976",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1540-76f2-9455-b0186f7cdd92",
        "storage_key": "property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcfS4vUsPlVQRVYCbJB05hN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ae59157e-d987-4e98-ba19-d9638006b436",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "poi_name": "Nike - Seb Coe",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Beaverton, OR 97006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-9518-74dd-9e5b-f07ecd4905d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-9518-74dd-9e5b-f07ecd4905d0",
        "storage_key": "property/6767906449166912/019d08b1-9518-74dd-9e5b-f07ecd4905d0.webp",
        "width": 805,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6550842833509833011&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nike---seb-coe",
      "poi_latitude": "45.5120496",
      "poi_longitude": "-122.8291215",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-1540-76f2-9455-b0186f7cdd92",
        "storage_key": "property/6767906449166912/019d08b1-1540-76f2-9455-b0186f7cdd92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHyGamtwOlVQRM1nEZtlE6Vo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_5656959d-e501-4fbf-aca8-421d47124d82",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_a7d3fbb4-2b47-407c-8e22-fcf2a68282f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_b84493b8-7ca7-4a2e-b67c-8270093048be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_d19119dd-22da-492f-888f-781469364a78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_7ae0b3fc-7664-475a-b5d5-c0e73f8a80fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_953993d9-5906-4bba-96a8-676f3367bf2f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_36ea7187-15bb-4d1c-9509-8483a0ed1536",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "day": "SUN",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_6cb39eb5-923c-4bfc-94ad-2cdfeec5832e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "rating": "5.0",
      "name": "K Knight",
      "text": "Our stay at Sunstone Parc was one of satisfaction. The upkeep of the apartment grounds were management's responsibility in which they always swiftly attended to and gave plenty of notice when doing so. Not only that, but the community amenities were always highly maintained for tenant use. If you were looking for a transitional or temporary place to live, we would recommend Sunstone Parc for the friendly neighborhood and fair rental price value. Now, in regards to the interior features, please know that it is not entirely glamorous, but it has simple yet serviceable units that should act well as a standard apartment stay. We, as previous tenants, want to highlight our experience and any recommendations we can provide for the move-in and move-out process. Our advice to future residents is to complete a written inspection of the unit shortly after moving in. This should eradicate any lack of communication when moving out and make the new tenant aware of what is properly functioning upon move in. As tenants, it's easy to get caught up in settling-in without taking the proper steps to making sure your unit is suitable for your living experience. In the midst of paperwork, we want to remind future tenants that there is one last utilities payment due after the return of the keys. This was something we felt got lost in translation, which is why we expressed our confusion to management. Fortunately, CTL Management was very keen on listening to our concerns, clearing up any/all miscommunication, and were willing to find a negotiable solution for our situation. For a property management establishment to be as sincere and accommodating as they were with us, says a lot about how much effort they put into keeping their tenants happy. It's also important to note, an arise of frustration can be normal when you live in close proximity to others and feel drowned out in the mix, but the managers of Sunstone Parc do their best to be attentive and transparent. It is for this reason, we felt satisfied with our stay.",
      "date": "2019-11-13",
      "title": ""
    },
    {
      "id": "custom_33159828-23df-4310-b363-a6fd1eaa3a0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "rating": "5.0",
      "name": "Gia Hudson",
      "text": "Very nice staff and good location. the apartments have a nice outlay. I love the floor to ceiling closet doors and the large patio windows. It is very spacious and welcoming environment. Very glad I moved here",
      "date": "2024-06-13",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_a22fef73-be6e-48d1-b2c2-dce18c94ab9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4486-b27d-71dd-87c5-cd3f4f34e89d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d4486-b27d-71dd-87c5-cd3f4f34e89d",
        "storage_key": "property/6767906449166912/019d4486-b27d-71dd-87c5-cd3f4f34e89d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sunstone Parc Apartments - 2 Bedroom 2 Bath 906 Sq. Ft. Model",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=rsZH9rA4vsn"
    },
    {
      "id": "custom_4c5a6c2f-4f8a-44aa-bf6d-c91c1541aa0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4486-dbb4-735c-9911-06e6f1e81091.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d4486-dbb4-735c-9911-06e6f1e81091",
        "storage_key": "property/6767906449166912/019d4486-dbb4-735c-9911-06e6f1e81091.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sunstone Parc Apartments - 2 Bedroom 2 Bath 906 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=bx4DzzKovt9"
    },
    {
      "id": "custom_ce1caeab-d1a0-4573-b9f9-e2752f1f3d66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4486-f30f-72b8-ae53-9cf51032e4cf.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d4486-f30f-72b8-ae53-9cf51032e4cf",
        "storage_key": "property/6767906449166912/019d4486-f30f-72b8-ae53-9cf51032e4cf.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sunstone Parc Apartments - Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=1JXZ9v98fqH"
    },
    {
      "id": "custom_940c4b0a-8e1c-489e-b9ec-0e17cc64b73e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4487-0a78-760b-9e43-701956a8a720.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d4487-0a78-760b-9e43-701956a8a720",
        "storage_key": "property/6767906449166912/019d4487-0a78-760b-9e43-701956a8a720.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sunstone Parc Apartments - Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=uXSBiZaAiJT"
    },
    {
      "id": "custom_8b903715-fc40-4f69-9ad9-a28894fae18c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166912/019d4487-1dee-75e9-b380-eb766d886a7e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d4487-1dee-75e9-b380-eb766d886a7e",
        "storage_key": "property/6767906449166912/019d4487-1dee-75e9-b380-eb766d886a7e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Sunstone Parc Apartments - Pool",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eSYLctEKLaz"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db1c0-727c-73b4-91ce-89b30fecfb48",
      "lead_source": "LANDING_PAGE",
      "name": "Sunstone Parc Apartments Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-beaverton-or",
      "search_query": "apartments with in-unit laundry Beaverton OR",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Beaverton",
      "h2_subtitle": "Discover Sunstone Parc, where in-unit laundry meets comfort and convenience in Beaverton, OR. Experience upscale living at its best.",
      "page_copy": "At Sunstone Parc, we understand the importance of convenience and comfort, which is why our apartments feature in-unit laundry facilities. Located in the heart of Beaverton, OR, our community offers a blend of modern amenities and tranquil surroundings. Each apartment is designed with your lifestyle in mind, providing additional storage and private patios for a unique living experience.\n\nOur smoke-free housing community proudly offers an array of amenities, including an outdoor spa and access to convenient garages. Situated in the welcoming neighborhood of Greenway, Sunstone Parc provides the perfect backdrop for your new home, where luxury and practicality converge. Come home to an apartment that truly meets your needs, with the ease of in-unit laundry and much more.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry Beaverton, OR",
      "seo_description": "Explore Sunstone Parc Apartments in Beaverton, OR, featuring in-unit laundry and more. Enjoy comfort and convenience in our welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "generator",
      "page_item_url": "24-hour-fitness-center-apartments-washington-county",
      "search_query": "24-hour fitness center apartments Washington County",
      "category": "Amenity",
      "h1_title": "24-Hour Fitness Center Apartments in Washington",
      "h2_subtitle": "Experience Sunstone Parc's unique amenities, including a 24-hour fitness center, right here in Washington County.",
      "page_copy": "Sunstone Parc is more than just a place to live; it's a lifestyle choice that includes a 24-hour fitness center designed to fit your schedule. Nestled in Washington County, our community boasts a serene setting with modern conveniences. Enjoy maintaining your active lifestyle without time constraints, as our fitness center is accessible around the clock.\n\nIn addition to our premium fitness amenities, Sunstone Parc offers residents private patios, additional storage, and smoke-free housing options. Relax in our outdoor spa or take advantage of our available garages. Located in the vibrant Greenway neighborhood of Beaverton, OR, our apartments provide the perfect mix of convenience, comfort, and health-focused living. Join our community where you can work, play, and relax with ease.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "24-Hour Fitness Center Apts Washington County",
      "seo_description": "Discover Sunstone Parc in Washington County, with a 24-hour fitness center and more. Enjoy a balanced lifestyle in our feature-rich community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "generator",
      "page_item_url": "apartments-swimming-pool-greenway-neighborhood",
      "search_query": "apartments with swimming pool Greenway neighborhood",
      "category": "Amenity",
      "h1_title": "Apartments with Swimming Pool in Greenway",
      "h2_subtitle": "Enjoy the luxury of a swimming pool at Sunstone Parc, located in the charming Greenway neighborhood.",
      "page_copy": "Come home to Sunstone Parc, where the refreshing escape of our swimming pool is just one of many enticing amenities. Nestled in the Greenway neighborhood, our apartments in Beaverton, OR, are the perfect retreat after a long day. Whether you're looking to unwind by the pool or enjoy a swim, our community caters to your relaxation needs.\n\nIn addition to a delightful swimming pool, residents can enjoy smoke-free living, additional storage options, and the privacy of their own patios. Our outdoor spa and convenient garage facilities add to the appeal, making Sunstone Parc more than just a place to live. Discover the balance of comfort and leisure in the vibrant environment of the Greenway neighborhood.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Greenway Neighborhood",
      "seo_description": "Sunstone Parc in Beaverton's Greenway offers an inviting swimming pool and more. Find relaxation and convenience in our feature-rich community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "generator",
      "page_item_url": "covered-parking-apartments-beaverton-or",
      "search_query": "covered parking apartments in Beaverton OR",
      "category": "Amenity",
      "h1_title": "Covered Parking Apartments in Beaverton",
      "h2_subtitle": "Discover the convenience of covered parking at Sunstone Parc, your future home in Beaverton, OR.",
      "page_copy": "At Sunstone Parc, we prioritize the convenience of our residents by offering covered parking options in the heart of Beaverton, OR. Our community is designed with modern living in mind, ensuring you have access to the amenities you need, like additional storage and private patios.\n\nSet in the welcoming Greenway neighborhood, Sunstone Parc is more than just a place to settle—it's a lifestyle choice. Enjoy the peace of mind that comes with smoke-free housing and unwind in our outdoor spa. With practical amenities like covered parking and garage options, Sunstone Parc provides the ultimate living experience for those seeking comfort and convenience in Beaverton.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Covered Parking Apartments in Beaverton OR",
      "seo_description": "Experience covered parking at Sunstone Parc in Beaverton, OR. Enjoy modern amenities and convenience in the Greenway neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "generator",
      "page_item_url": "apartments-fireplaces-near-beaverton",
      "search_query": "apartments with fireplaces near Beaverton",
      "category": "Amenity",
      "h1_title": "Apartments with Fireplaces Near Beaverton",
      "h2_subtitle": "Enjoy cozy living with fireplaces at Sunstone Parc, located conveniently near Beaverton.",
      "page_copy": "Sunstone Parc offers charming apartments with fireplaces, perfect for creating a warm, inviting atmosphere just outside Beaverton. Situated in the peaceful Greenway neighborhood, our community combines modern convenience with cozy comforts. Imagine relaxing by your fireplace after a day exploring Beaverton's vibrant scene.\n\nOur community extends beyond fireplaces with features like private patios and additional storage, ensuring a comfortable living experience. Residents benefit from smoke-free housing and the luxury of an outdoor spa, plus convenient parking options, including garages. Experience the welcoming environment of Sunstone Parc, where you can enjoy the perfect blend of cozy and contemporary lifestyle, right near Beaverton.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fireplaces Near Beaverton",
      "seo_description": "Discover cozy apartment living with fireplaces at Sunstone Parc, conveniently located near Beaverton in the inviting Greenway neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-beaverton-or",
      "search_query": "one bedroom apartments Beaverton OR",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Beaverton, OR",
      "h2_subtitle": "Find your ideal one bedroom apartment at Sunstone Parc, nestled in Beaverton, OR.",
      "page_copy": "Sunstone Parc is the perfect choice for those seeking one bedroom apartments in Beaverton, OR. Our thoughtfully designed layouts ensure comfort and functionality, all within the serene Greenway neighborhood. Enjoy spacious living matched with modern amenities like private patios and additional storage.\n\nOur community extends beyond just one bedroom apartments, offering smoke-free housing, an outdoor spa, and practical amenities such as covered parking and garages. Sunstone Parc provides the ideal blend of privacy and community, allowing you to enjoy the best that Beaverton has to offer. Discover simple yet sophisticated living in a vibrant and welcoming environment at Sunstone Parc.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Beaverton, OR",
      "seo_description": "Explore one bedroom apartments at Sunstone Parc in Beaverton, OR. Enjoy modern amenities and serene living in the Greenway neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-greenway",
      "search_query": "two bedroom apartments near Greenway",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Greenway",
      "h2_subtitle": "Discover spacious two bedroom apartments at Sunstone Parc, conveniently near Greenway.",
      "page_copy": "Experience comfortable and spacious living at Sunstone Parc, offering two bedroom apartments near the serene Greenway neighborhood. Nestled in an ideal location, our apartments are designed with modern amenities such as private patios and additional storage to enhance your living experience.\n\nSunstone Parc provides a smoke-free environment with added luxuries like an outdoor spa, ensuring a relaxing home life. Convenient features such as covered parking and garages are also available, making life even easier. Choose Sunstone Parc for a lifestyle that combines comfort, convenience, and a welcoming community right near Greenway.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near Greenway",
      "seo_description": "Explore two bedroom apartments at Sunstone Parc near Greenway. Enjoy spacious living with modern amenities in a peaceful community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "generator",
      "page_item_url": "three-bedroom-floor-plans-washington-county",
      "search_query": "three bedroom floor plans Washington County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Floor Plans in Washington County",
      "h2_subtitle": "Explore spacious three bedroom floor plans at Sunstone Parc in Washington County.",
      "page_copy": "Sunstone Parc offers thoughtfully designed three bedroom floor plans, ideally located in Washington County. Our expansive layouts provide ample space for you and your family to enjoy in the tranquil setting of the Greenway neighborhood. Discover the perfect home that combines style with comfort, ensuring every member has their own space.\n\nIn addition to spacious interiors, Sunstone Parc boasts a range of modern amenities including private patios, additional storage, and convenient smoke-free housing. Residents can unwind at the outdoor spa or enjoy the ease of garages and covered parking. Choose Sunstone Parc for a community-centric lifestyle enriched by the balance of nature and modern living in Washington County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Floor Plans in Washington County",
      "seo_description": "Discover three bedroom floor plans at Sunstone Parc in Washington County. Enjoy spacious living with modern amenities in a serene community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "generator",
      "page_item_url": "apartments-near-portland-community-college-sylvania",
      "search_query": "apartments near portland community college sylvania beaverton",
      "category": "School",
      "h1_title": "Apartments Near PCC Sylvania in Beaverton",
      "h2_subtitle": "Find the perfect home at Sunstone Parc, conveniently located near Portland Community College Sylvania.",
      "page_copy": "Sunstone Parc offers modern apartments near Portland Community College Sylvania, providing the ideal living situation for students and faculty alike. Nestled in Beaverton's Greenway area, our location offers easy access to educational opportunities while residing in a friendly, community-focused environment.\n\nWe offer an array of amenities such as private patios, additional storage, and smoke-free housing, ensuring a comfortable living experience. Make the most of our outdoor spa and convenient garages as part of the complete modern living package. Choose Sunstone Parc for the perfect combination of academic convenience and a welcoming home environment in Beaverton.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near PCC Sylvania in Beaverton",
      "seo_description": "Explore Sunstone Parc apartments near PCC Sylvania in Beaverton. Enjoy modern amenities in a student-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "generator",
      "page_item_url": "apartments-near-providence-st-vincent-hospital-east-pavilion",
      "search_query": "apartments near Providence St. Vincent Hospital East Pavilion Beaverton",
      "category": "Hospital",
      "h1_title": "Apartments Near Providence St. Vincent Hospital",
      "h2_subtitle": "Discover convenient living at Sunstone Parc, near Providence St. Vincent Hospital East Pavilion in Beaverton.",
      "page_copy": "Living close to work has never been easier with Sunstone Parc's ideal location near Providence St. Vincent Hospital East Pavilion in Beaverton. Our apartments offer a perfect balance of convenience and comfort, ensuring you have a peaceful home environment after a busy day at the hospital.\n\nSunstone Parc features modern amenities like private patios and additional storage, along with a smoke-free community that prioritizes quality of life. Residents can relax at the outdoor spa and take advantage of covered parking and garages. Choose Sunstone Parc for a seamless blend of proximity to Providence St. Vincent Hospital and a comfortable lifestyle in Beaverton.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Providence St. Vincent Hospital",
      "seo_description": "Explore Sunstone Parc, offering convenient apartments near Providence St. Vincent Hospital East Pavilion in Beaverton with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "generator",
      "page_item_url": "beaverton-apartments-close-to-providence-st-vincent-medical-center",
      "search_query": "Beaverton apartments close to Providence St. Vincent Medical Center",
      "category": "Hospital",
      "h1_title": "Beaverton Apartments Near Providence St. Vincent",
      "h2_subtitle": "Sunstone Parc offers top-notch living close to Providence St. Vincent Medical Center in Beaverton.",
      "page_copy": "For those seeking a short commute, Sunstone Parc offers premier living just a stone's throw from Providence St. Vincent Medical Center in Beaverton. Our apartments are perfectly positioned for healthcare professionals and those desiring quick access to medical services. \n\nEnjoy a host of amenities at Sunstone Parc, including private patios, additional storage options, and smoke-free living, ensuring a healthy environment. With relaxing features like an outdoor spa and the convenience of garages, our community makes coming home the best part of your day. Choose Sunstone Parc for a comfortable lifestyle in a convenient Beaverton location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Beaverton Apartments Near Providence St. Vincent",
      "seo_description": "Discover Beaverton apartments close to Providence St. Vincent Medical Center. Enjoy modern living with Sunstone Parc's excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "generator",
      "page_item_url": "apartments-near-cook-family-park-beaverton",
      "search_query": "apartments near Cook Family Park Beaverton",
      "category": "Park",
      "h1_title": "Apartments Near Cook Family Park in Beaverton",
      "h2_subtitle": "Experience community living at Sunstone Parc, just steps from Cook Family Park in Beaverton.",
      "page_copy": "At Sunstone Parc, enjoy living in a welcoming community with the added benefit of being near Cook Family Park in Beaverton. Perfect for those who love the outdoors, this location offers ample opportunities for recreation and leisure.\n\nOur apartments provide modern features like private patios and additional storage, ensuring comfort and convenience. Enjoy smoke-free housing and utilize the outdoor spa and garages for a complete lifestyle upgrade. Sunstone Parc is the ideal choice for those looking to connect with nature while enjoying the perks of modern apartment living near Cook Family Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Cook Family Park in Beaverton",
      "seo_description": "Explore Sunstone Parc, offering modern apartments near Cook Family Park in Beaverton. Enjoy a blend of nature and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "generator",
      "page_item_url": "gabriel-park-nearby-apartments-greenway",
      "search_query": "Gabriel Park nearby apartments Greenway",
      "category": "Park",
      "h1_title": "Apartments Close to Gabriel Park in Greenway",
      "h2_subtitle": "Discover serene living at Sunstone Parc, located near Gabriel Park in the Greenway neighborhood.",
      "page_copy": "Reside at Sunstone Parc and experience the tranquility of living close to Gabriel Park in the Greenway area. Ideal for families and nature lovers, this location provides easy access to outdoor spaces while still being within a vibrant community.\n\nSunstone Parc offers amenities such as private patios, additional storage, and a smoke-free environment, making it a preferred choice for comfortable living. Relax in our outdoor spa and enjoy the convenience of on-site garages. Visit Sunstone Parc where the proximity to Gabriel Park enhances the charm of Greenway living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Gabriel Park in Greenway",
      "seo_description": "Enjoy Greenway living at Sunstone Parc, featuring modern apartments near Gabriel Park with excellent amenities and a serene environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "generator",
      "page_item_url": "tryon-creek-state-natural-area-apartments-washington-county",
      "search_query": "Tryon Creek State Natural Area apartments Washington County",
      "category": "Park",
      "h1_title": "Apartments Near Tryon Creek in Washington County",
      "h2_subtitle": "Explore Sunstone Parc, ideally located for nature lovers near Tryon Creek State Natural Area in Washington County.",
      "page_copy": "Discover Sunstone Parc, where you can embrace both modern living and natural beauty. Positioned near Tryon Creek State Natural Area in Washington County, our apartments offer a unique setting for those who appreciate the outdoors.\n\nSunstone Parc features a range of amenities, including private patios and additional storage options, catering to a comfortable lifestyle. Enjoy smoke-free housing and unwind in our outdoor spa. With convenient on-site garages, Sunstone Parc is perfect for residents seeking an enriching living experience near Tryon Creek State Natural Area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tryon Creek in Washington County",
      "seo_description": "Experience nature and comfort at Sunstone Parc, with modern apartments near Tryon Creek State Natural Area in Washington County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "generator",
      "page_item_url": "tualatin-hills-nature-park-close-to-apartments-97008",
      "search_query": "Tualatin Hills Nature Park close-to apartments 97008",
      "category": "Park",
      "h1_title": "Apartments Near Tualatin Hills Nature Park 97008",
      "h2_subtitle": "Sunstone Parc offers prime living in 97008, close to Tualatin Hills Nature Park, perfect for nature enthusiasts.",
      "page_copy": "Nestled in the 97008 area, Sunstone Parc provides an exceptional living experience close to Tualatin Hills Nature Park. Immerse yourself in stunning natural surroundings while enjoying the conveniences of modern apartment living.\n\nOur community features amenities such as private patios, additional storage, and a smoke-free environment, enhancing comfort and convenience. Residents also benefit from our outdoor spa and garages. Embrace a unique lifestyle at Sunstone Parc, where proximity to Tualatin Hills Nature Park makes life more refreshing and invigorating.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tualatin Hills Nature Park 97008",
      "seo_description": "Find your new home at Sunstone Parc, offering convenient apartments near Tualatin Hills Nature Park in the 97008 area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "generator",
      "page_item_url": "apartments-near-beaverton-tc-max-station",
      "search_query": "apartments near Beaverton TC MAX Station Beaverton",
      "category": "Transit",
      "h1_title": "Apartments by Beaverton TC MAX Station",
      "h2_subtitle": "Live near Beaverton TC MAX Station at Sunstone Parc, offering convenience and connectivity in Beaverton.",
      "page_copy": "Sunstone Parc is your gateway to hassle-free commuting, located conveniently near the Beaverton TC MAX Station. Ideal for those seeking connectivity and urban living, our community in Beaverton offers effortless access to public transportation.\n\nBeyond location, Sunstone Parc provides residents with smoke-free housing, private patios, and additional storage, catering to modern lifestyle needs. The amenities include an outdoor spa and on-site garages, creating a comfortable environment right in Beaverton. Experience the blend of comfort and convenience at Sunstone Parc, steps away from the Beaverton TC MAX Station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Beaverton TC MAX Station",
      "seo_description": "Discover easy urban living at Sunstone Parc, offering modern apartments near Beaverton TC MAX Station for convenient commuting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "generator",
      "page_item_url": "sunstone-parc-close-to-elmonica-sw-170th-ave",
      "search_query": "Sunstone Parc close to Elmonica SW 170th Ave",
      "category": "Transit",
      "h1_title": "Sunstone Parc Near Elmonica SW 170th Ave",
      "h2_subtitle": "Experience living at Sunstone Parc, conveniently close to Elmonica SW 170th Ave, blending accessibility and comfort.",
      "page_copy": "Sunstone Parc offers a prime location for those desiring proximity to Elmonica SW 170th Ave. Situated in Beaverton, our community provides easy access to this bustling area, enhancing both convenience and connectivity.\n\nResidents at Sunstone Parc enjoy a comfortable lifestyle with amenities such as additional storage and private patios, alongside a smoke-free environment. The outdoor spa and available garages add a touch of luxury and practicality. Discover the ideal blend of accessibility and modern living at Sunstone Parc, just moments from Elmonica SW 170th Ave.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sunstone Parc Near Elmonica SW 170th Ave",
      "seo_description": "Discover Sunstone Parc, offering modern amenities and prime location near Elmonica SW 170th Ave in Beaverton.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "generator",
      "page_item_url": "greenway-beaverton-millikan-way-nearby",
      "search_query": "Greenway Beaverton Millikan Way nearby",
      "category": "Transit",
      "h1_title": "Greenway Apartments Near Millikan Way",
      "h2_subtitle": "Discover the Greenway lifestyle in Beaverton, with Millikan Way nearby, offering convenience and vibrant living.",
      "page_copy": "Located in the heart of Beaverton's Greenway neighborhood, Sunstone Parc provides easy access to Millikan Way, making it a perfect choice for those who value convenience. This prime location connects you effortlessly to shops, dining, and transportation.\n\nSunstone Parc residents enjoy smoke-free, comfortable living with features like private patios and extra storage. The community also offers luxurious amenities like an outdoor spa and garages, ensuring you have everything you need for a modern lifestyle near Millikan Way. Come experience the blend of accessibility and comfort at Sunstone Parc.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Greenway Apartments Near Millikan Way",
      "seo_description": "Experience Greenway living at Sunstone Parc, conveniently situated near Millikan Way in Beaverton.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "generator",
      "page_item_url": "sunset-tc-eastbound-apartments-washington-county",
      "search_query": "Sunset TC Eastbound apartments in Washington County",
      "category": "Transit",
      "h1_title": "Apartments Near Sunset TC Eastbound",
      "h2_subtitle": "Sunstone Parc offers ideal living near Sunset TC Eastbound, combining convenience and comfort in Washington County.",
      "page_copy": "Located in Washington County, Sunstone Parc is perfect for commuters with its proximity to Sunset TC Eastbound. This prime spot ensures easy travel and access to Beaverton's vibrant community amenities.\n\nAt Sunstone Parc, residents enjoy smoke-free living with private patios and added storage options. Our community also features an outdoor spa and available garages, creating a sophisticated living experience. Explore the ease and comfort of living near Sunset TC Eastbound at Sunstone Parc, where convenience meets modern living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sunset TC Eastbound",
      "seo_description": "Live near Sunset TC Eastbound in Washington County at Sunstone Parc, offering modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166912",
      "source": "generator",
      "page_item_url": "beaverton-creek-proximity-beaverton-oregon-rentals",
      "search_query": "Beaverton Creek proximity to Beaverton Oregon rentals",
      "category": "Transit",
      "h1_title": "Beaverton Rentals Near Beaverton Creek",
      "h2_subtitle": "Sunstone Parc offers rentals with easy access to Beaverton Creek in the Beaverton, Oregon area, providing an ideal living experience.",
      "page_copy": "Situated in Beaverton, Oregon, Sunstone Parc offers rentals that boast proximity to the serene Beaverton Creek. This ideal location combines natural beauty with urban convenience, making it perfect for those seeking both tranquility and accessibility.\n\nEnjoy a smoke-free environment with luxurious amenities at Sunstone Parc, including private patios and additional storage. Our community also features a relaxing outdoor spa and garages, providing a comfortable lifestyle with easy access to Beaverton Creek's scenic surroundings. Experience the best of Beaverton living at Sunstone Parc.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Beaverton Rentals Near Beaverton Creek",
      "seo_description": "Discover Beaverton rentals at Sunstone Parc, featuring proximity to Beaverton Creek and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5629"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372408882"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "\tGTM-K2C8H8FC\t"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-610-5034 "
    }
  ],
  "custom_qb_id": "5629",
  "custom_repli_id": "18372408882",
  "custom_google_gtm_id": "\tGTM-K2C8H8FC\t",
  "custom_ppc_tracking_phone_number": "844-610-5034 "
};

export const generatedAt = '2026-09-23T19:54:11.799Z';
